
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';
/*封装系统中常用的公共方法*/
import axios from 'axios';
import api from '@/api/';
import proxyFile from "../../proxy";
import store from '@/store/store';
import {Message, Modal} from "view-design";
import {showBillConfirmed} from "@/utils/asist";
import {
  MALL_DISTRIBUTOR_CONFIG_KEY, SAAS_PARAM_KEYS, SUPPLIER_CONFIG_KEY, USER_DISTRIBUTOR_CONFIG_KEY,
  USER_SUPPLIER_CONFIG_KEY, VALIDATEMERCHANTCONFIGKEY, YMS_MERCHANT_CONFIG_KEY,
  setConfigCharacters
} from "@/utils/enum";
import Vue from 'vue';
import regular from "@/utils/tools/regular";
import uDate from '@/utils/tools/date';

// 系统服务映射
const SERVICE_MAP = {
  yms: '/yms-core-service',
  shopping: '/yms-core-service',
  supplier: '/yms-supplier-service',
  distributor: '/yms-distributor-service'
};

// 创建一个事件总线
export const EventBus = new Vue();
let pageInitFailureModalVisible = false;
let webDataCollectionKey = '';
// 标记拦截器是否已处理
export let isInterceptorHandled = false;
// 标记拦截器已处理
export const markInterceptorHandled = () => {
  isInterceptorHandled = true;
};
// 重置拦截器处理状态
export const resetInterceptorHandled = () => {
  isInterceptorHandled = false;
};
// 获取系统类型
export const getSystemType = () => localStorage.getItem('system') || store.state.system;
// 默认语种值为zh-CN
export const defaultLanguages = 'zh-CN';
// 获取当前系统设置的语种值
export const getSetLanguages = () => localStorage.getItem('setLanguages') || store.state.setLanguages || defaultLanguages;
// 判断是否是中文语种标识
export const isChineseLanguage = () => getSetLanguages() === defaultLanguages;
// 获取当前仓库ID
export const getWarehouseId = () => commonLocalStorage.getItem('warehouseId') ||
  commonSessionStorage.getItem('warehouseId') || store.state.warehouseId;

// 处理缓存到sessionStorage的数据
export const commonSessionStorage = {
  setItem(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key) {
    const value = sessionStorage.getItem(key) || '';
    try {
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return value;
    }
    return value ? JSON.parse(value) : null;
  },
  removeItem(key) {
    sessionStorage.removeItem(key);
  }, clearAllItem() {
    sessionStorage.clear();
  }
}

// 处理缓存到localStorage的数据
export const commonLocalStorage = {
  setItem(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  getItem(key) {
    const value = localStorage.getItem(key) || '';
    try {
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return value;
    }
    return value ? JSON.parse(value) : null;
  },
  removeItem(key) {
    localStorage.removeItem(key);
  }
}


// 处理获取指定的系统服务
function handleService(pathname) {
  let service = '';
  const serviceList = [{pathname: '/yms.html', service: 'yms-core-service'}, {
    pathname: '/supplier.html',
    service: 'yms-supplier-service'
  }, {pathname: '/distributor.html', service: 'yms-distributor-service'}];
  serviceList.map((item) => {
    if (pathname.includes(item.pathname)) {
      service = item.service;
    }
  });
  return service;
}

// 添加语言样式
export const addLangStyle = () => {
  let link = document.createElement('link');
  link.rel = 'stylesheet';
  let path = './static/css/';
  let talg = window.location.href.split('//');
  if (talg[1].includes('localhost')) {
    path = getProxyUrl() + '/static/css/';
  }
  link.href = path + localStorage.getItem('lang') + '.css';
  document.getElementsByTagName('head')[0].appendChild(link);
}

// 根据userId批量获取用户信息
export const getUserInfoByUserIdsData = (userIds, v) => {
  return new Promise(resolve => {
    if (userIds.length > 0) {
      axios.post(api.get_userInfo_queryMapByUserIds, userIds).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            v.userInfoList = data;
            resolve(data);
          } else {
            resolve(false);
          }
          return;
        }
        resolve(false);
      }).catch((e) => {
        console.error('getUserInfoByUserIdsData error:', e);
        resolve(false);
      })
    } else {
      resolve(false);
    }
  });
}

// 根据 userId 匹配获取用户名称
export const getUserNameByUserId = (userId, userInfoList = {}, path = '') => {
  // 跨系统操作时，按页面路由映射默认操作人名称
  const PATH_CROSS_OPERATOR_MAP = {
    '/supplierOrders': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001642'),
    '/distributorStockList': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001642'),
    '/newProductReviewList': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001642'),
    '/productReviewForSaleList': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001642'),
    '/accountManage/collectionAccount': aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001643'),
  };
  if (userId === aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000349')) return aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000349');
  return userInfoList[userId]?.userName || PATH_CROSS_OPERATOR_MAP[path] || '';
};

// 校验数值是否为空，不包括0
export const isValueEmpty = (value) => {
  return value === null || value === undefined || isNaN(value) || value === '';
}
// 校验字符串是否为空
export const isStringValueEmpty = (value) => {
  return value === null || value === undefined || value === '';
}

// 处理图片的放大图片的样式(默认放大的图片最大的尺寸为300*300)
export const handlerImgSize = (imgWidth, imgHeight) => {
  const MAX_SIZE = 300;
  const style = {verticalAlign: 'middle'};
  // 没有尺寸，给默认
  if (!imgWidth && !imgHeight) {
    return {
      ...style,
      width: `${MAX_SIZE}px`,
      height: 'auto'
    };
  }
  // 横图
  if (imgWidth >= imgHeight) {
    return {
      ...style,
      width: `${Math.min(imgWidth, MAX_SIZE)}px`,
      maxWidth: `${MAX_SIZE}px`,
      height: 'auto'
    };
  }
  // 竖图
  return {
    ...style,
    height: `${Math.min(imgHeight, MAX_SIZE)}px`,
    maxHeight: `${MAX_SIZE}px`,
    width: 'auto'
  };
};

// 根据菜单路由获取对应菜单的id，高亮显示菜单
export const getMenuRoutingId = (path) => {
  if (!path) return 0;
  let menuData = [];
  try {
    menuData = commonLocalStorage.getItem('pagesPermissions') || [];
  } catch (e) {
    return 0;
  }
  if (!Array.isArray(menuData) || menuData.length === 0) return 0;
  const stack = [...menuData];
  while (stack.length) {
    const node = stack.pop();
    if (node?.path === path) return node.id || 0;
    const children = node?.children;
    if (Array.isArray(children) && children.length) {
      stack.push(...children);
    }
  }
  return 0;
};

// 前端数据的排序 （默认降序）desc  升序：asc
export const handerDataSorting = (property, type) => {
  return function (obj1, obj2) {
    let value1 = obj1[property];
    let value2 = obj2[property];
    return type === 'asc' ? value1 - value2 : value2 - value1;
  };
}

// 导入、导出下载文件
export const downloadTemplateFile = (url, type) => {
  let erpConfig = commonSessionStorage.getItem("erpConfig") || store.state.erpConfig;
  let filenodes = erpConfig.filenodeViewTargetUrl;
  if (url.includes('https://') || url.includes('http://')) {
    if (url.includes('http://')) {
      url = url.replace('http://', 'https://');
    }
    window.open(url, type);
  } else {
    let pathname = window.location.pathname;
    let talg = window.location.href.split('//');
    let link = '';
    let target = proxyFile['/'].target;
    let service = handleService(pathname);
    let path = window.location.href.split('/');
    let filenodeViewTargetUrl = filenodes.split('.')[1] || filenodes.split(path[2])[1];
    if (talg[1].includes('localhost')) {
      link = `${target}/${service}${filenodeViewTargetUrl}${url}`;
      window.open(link, type);
    } else {
      window.open(filenodes + url, type);
    }
  }
}

/**
 * @Description: 前端自动拼接完整路径
 * @params:
 * spliceValue 链接中是否拼接了 ./filenode/s
 */
export const setLinkPath = (path, spliceValue = false) => {
  if (!path) return '';
  // 已是完整地址
  if (regular.matchHttpHttps.test(path)) return path;
  const systemType = getSystemType();
  const isLocalhost = window.location.href.includes('localhost');
  const target = proxyFile['/'].target.replace(/\/$/, '');
  const service = SERVICE_MAP[systemType] || '';
  // 处理 filenode 路径
  const newPath = spliceValue ? path.replace(/^\.\/filenode\/s/, '/filenode/s') : path;
  const erpConfig = commonSessionStorage.getItem('erpConfig') || store.state.erpConfig;
  // ===== spliceValue = true 的逻辑（优先级最高）=====
  if (spliceValue) {
    if (isLocalhost) {
      return target + service + newPath;
    }
    return newPath;
  }
  // ===== spliceValue = false，依赖 erpConfig =====
  if (!erpConfig) return '';
  const filenodes = erpConfig.filenodeViewTargetUrl;
  const filenodeViewTargetUrl = filenodes.split('.')[1];
  if (isLocalhost) {
    return target + service + filenodeViewTargetUrl + path;
  }
  return filenodes + path;
};

/**
 * @Description:
 * 1.是优先匹配当前需求中列举出来的对应快递code，跳转到对应的快递查询快递信息，
 * 2.如果匹配不上就会按照之前的需求，默认跳转到快递100进行查询（有code和快递单号的情况下）
 * 3.如果当前没有code和快递单号就是默认跳转到快递100按照顺丰根据运单号查询
 *
 * @params:
 * expressageCode 快递公司code
 * expressageNo 快递单号
 * trackingNumber 运单号
 */
export const jumpToTheCourierInquiry = (expressageCode, expressageNo, trackingNumber) => {
  // 快递100的地址
  const EXPRESS_100 = 'http://www.kuaidi100.com/chaxun';
  // 如果当前没有 code 和快递单号就是默认跳转到快递100按照顺丰根据运单号查询
  if (!expressageCode || !expressageNo) {
    const code = 'shunfeng';
    const link = `${EXPRESS_100}?com=${code}&nu=${trackingNumber}`;
    window.open(link, '_blank');
    return;
  }
  axios.get(`${api.get_expressageHundred_query}?type=kuaidi100`).then((response) => {
    if (response.data.code !== 0) return;
    const list = response.data.datas || [];
    if (!list.length) return;
    // 优先匹配当前需求中列举出来的对应快递code
    const matched = list.find((item) => item.code === expressageCode);
    let courierLink = '';
    if (matched) {
      // 1. 优先跳转到对应快递查询快递信息
      if (matched.url) {
        courierLink = handleExpressLink(matched.url, expressageNo);
      }
      // 2. 匹配不上则默认跳转快递100（有code和快递单号）
      else {
        courierLink = `${EXPRESS_100}?com=${expressageCode}&nu=${expressageNo}`;
      }
      // 如果是 联昊通物流 需要自动复制单号
      if (['lianhaowuliu'].includes(expressageCode)) {
        commonCopyContent(expressageNo || trackingNumber);
      }
    }
    if (courierLink) {
      window.open(courierLink, '_blank');
    }
  });
  
  function handleExpressLink(url, expressageNo) {
    const tagName = '${expressageNo}';
    if (!url) return '';
    return url.includes(tagName) ? url.replace(tagName, expressageNo) : url;
  }
};

/**
 * @Description: 针对 InputNumber formatter 处理保留对应的小数点位数
 * @params: VauleNumber 数值， length 保留的小数点位数（默认保留两位小数）
 */
export const formatterNumber = (VauleNumber, length = 2) => {
  let newNumber = null;
  if (!isNaN(VauleNumber)) {
    if (VauleNumber >= 0) {
      let reg = /.*\..*/
      if (reg.test(VauleNumber) && String(VauleNumber).split(".")[1].length > length) {
        newNumber = parseFloat(VauleNumber).toFixed(length)
      } else {
        newNumber = VauleNumber
      }
    }
    return newNumber
  }
  return 0
};

/**
 * @Description: 获取打印控件的下载地址的公共方法
 * @params: 例：https://admin-test.pvt.yms.com/yms-core-service/filenode/s/yms-core-service/tool/TongtoolPrinter.exe
 */
export const downloadControl = (fileName) => {
  return new Promise((resolve) => {
    let pathname = window.location.pathname;
    let talg = window.location.href.split('//');
    let link = '';
    let target = proxyFile['/'].target;
    let service = handleService(pathname);
    let path = window.location.href.split('/');
    let erpConfig = commonSessionStorage.getItem("erpConfig") || store.state.erpConfig;
    let filenodes = erpConfig.filenodeViewTargetUrl;
    let filenodeViewTargetUrl = filenodes.split('.')[1] || filenodes.split(path[2])[1];
    if (talg[1].includes('localhost')) {
      link = `${target}/${service}${filenodeViewTargetUrl}/${service}${fileName}`;
    } else {
      link = `${filenodes}/${service}${fileName}`;
    }
    Modal.info({
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'), okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'), render: (h, params) => {
        return h('div', {
          class: 'mt10 flex flex-wrap'
        }, [h('div', {class: 'font-size-15'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001644')), h('a', {
          attrs: {href: link, target: '_blank'}, class: 'font-weight-bold font-size-15 ml2 mr2',
        }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001645')), h('div', {class: 'font-size-15'}, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001646'))]);
      }, onOk: () => {
        resolve(true);
      }
    });
  });
}


/**
 * @Description: 运营系统---校验拣货单中出库单状态
 * @params: url：接口  ymsPickingOrderIds：拣货单流水号
 */
export const ymsVerifyPicking = (url, ymsPickingOrderIds) => {
  return new Promise((resolve => {
    let query = {
      ymsPickingOrderIds: ymsPickingOrderIds
    }
    axios.put(url, query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('ymsVerifyPicking error:', e);
      resolve([]);
    });
  }));
}

/**
 * @Description: 供应商系统---校验拣货单中出库单状态
 * @params: url：接口  pickingGoodsNos：拣货单编号
 */
export const supplierVerifyPicking = (url, pickingGoodsNos) => {
  return new Promise((resolve => {
    let query = {
      pickingGoodsNos: pickingGoodsNos
    }
    axios.put(url, query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('supplierVerifyPicking error:', e);
      resolve([]);
    });
  }));
}

/**
 * @Description: 根据广告类型跳转到指定链接
 * @params: data 当前广告数据
 */
export const advertisingLinkAddress = (data = {}) => {
  if (!data) return;
  const {jumpTargetType, jumpTargetName, jumpTargetValue} = data;
  const jumpMap = {
    // 活动
    0: () => pageJump(
      `/index.html#/shopList?activityTitle=${jumpTargetName}&ymsActivityPlanId=${jumpTargetValue}`,
      '/yms-shopping-service',
      '_blank'
    ),
    // 指定链接
    1: () => window.open(jumpTargetValue, '_blank'),
    // 分类
    2: () => pageJump(
      `/index.html#/shopList?ymsProductCategoryId=${jumpTargetValue}`,
      '/yms-shopping-service',
      '_blank'
    )
  };
  jumpMap[jumpTargetType]?.();
};


/**
 * @Description: 页面之间的跳转方法
 * @params:
 * url：跳转的链接地址
 * service：跳转到的服务
 * type：窗口打的方式 （_self：在当前窗口打开  _blank 在新窗口打开）
 * links 重定向的链接地址
 */
export const pageJump = (url, service, type, links) => {
  let talg = window.location.href.split('//');
  let tagLink = links ? links : '';
  if (talg[1].includes('localhost')) {
    let link = `${talg[0]}//${window.location.host}${url}` + tagLink;
    window.open(link, type);
  } else {
    let shoppingInfo = store.state.shoppingInfo;
    let link = `${service + url}` + tagLink;
    if (shoppingInfo && shoppingInfo.shoppingDomain) {
      let origin = shoppingInfo.shoppingDomain.replace(/\.com.*/, '.com');
      link = origin + link;
    }
    window.open(link, type);
  }
};

/**
 * 组装访问地址
 * @date: 2022/3/31 14:03
 * url：跳转的链接地址
 * service：跳转到的服务
 * type：窗口打的方式 （_self：在当前窗口打开  _blank 在新窗口打开
 */
export const getHrefPath = (url, service, links) => {
  let talg = window.location.href.split('//');
  let tagLink = links ? links : '';
  if (talg[1].includes('localhost')) {
    return `${talg[0]}//${window.location.host}${url}`;
  } else {
    let link = `${service + url}` + tagLink;
    let shoppingInfo = store.state.shoppingInfo;
    if (shoppingInfo && shoppingInfo.shoppingDomain) {
      let origin = shoppingInfo.shoppingDomain.replace(/\.com.*/, '.com');
      link = origin + link;
    }
    return link;
  }
};

/**
 * @Description:
 * 跨系统跳转链接的时候，会存在访问权限问题，所以在跳转的时候，需要指定完整的链接地址
 * 在不同的环境下，配置各个系统链接地址
 * @params:
 * url 跳转的链接地址
 * system 跳转到指定的系统
 */

export const crossSystemJumpLink = (url, system) => {
  if (!url) return '';
  const isLocalhost = window.location.origin.includes('localhost');
  // 本地环境：直接用当前协议 + host
  if (isLocalhost) {
    return `${window.location.protocol}//${window.location.host}${url}`;
  }
  // 从配置中取对应系统域名
  const pageConfig = commonLocalStorage.getItem('pageConfig') || store.state.pageConfig;
  if (!pageConfig) return '';
  const domainMap = {
    yms: pageConfig.ymsCoreDomain,
    distributor: pageConfig.distributorDomain,
    supplier: pageConfig.supplierDomain
  };
  return (domainMap[system] || '') + url;
};

// 获取url里面的参数
export const getQueryString = name => {
  let reg = new RegExp('(^|&?)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.href.substr(1).match(reg);
  if (r !== null) {
    return unescape(r[2]);
  } else {
    return null;
  }
};

/**
 * @Description: 删除ticket参数@
 * @params: url
 */
export const deleteTicket = (url) => {
  if (url.includes('ticket')) {
    let arr = url.split('?');
    let params = arr[1].split('&');
    let paramsR = params.filter(i => {
      if (!i.includes('ticket') && i) {
        return i;
      }
    });
    if (paramsR && paramsR.length > 0) {
      return arr[0] + '?' + paramsR.join('&');
    } else {
      if (arr[0][arr[0].length - 1] === '/') {
        return arr[0].slice(0, -1);
      } else {
        return arr[0];
      }
    }
  } else {
    return url;
  }
};

/**
 * 登录回调后从路由 query 中移除 ticket，供 router.replace 使用
 * @param {Object} to vue-router 目标路由
 * @returns {Object|null} replace 导航对象，无 ticket 时返回 null
 */
export const getRouteWithoutTicket = (to) => {
  if (!to.query || !to.query.ticket) return null;
  const query = {...to.query};
  delete query.ticket;
  return {path: to.path, query, replace: true};
};

// 校验登录的时候才提示弹窗
export const verifyLoginTicket = () => {
  return new Promise(resolve => {
    let talg = false;
    if (window.location.href.includes('ticket=')) {
      let newTicket = getQueryString('ticket');
      let old = commonSessionStorage.getItem('oldTicket');
      talg = newTicket !== old;
      if (talg) {
        // 登录系统成功之后，延迟30秒将新的ticket存入sessionStorage中
        setTimeout(() => {
          commonSessionStorage.setItem('oldTicket', newTicket)
        }, 30 * 1000);
      }
    }
    resolve(talg);
  });
}

// 查询商城中正在进行中的活动
export const getOngoingActivities = (type) => {
  let href = window.location.href;
  let ongoingActivitiesData = store.state.ongoingActivitiesData || commonSessionStorage.getItem('ongoingActivitiesData');
  
  const defaultList = [{activityTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000033'), activityType: 'all'}, {activityTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001647'), activityType: 'news'}];
  const getData = async (url) => {
    try {
      const response = await axios.get(url);
      if (response.data.code !== 0) return defaultList;
      let data = response.data.datas || [];
      data.map((item) => {
        item.activityType = item.ymsActivityPlanId;
      });
      let newList = [...defaultList, ...data];
      store.commit('ongoingActivitiesData', newList);
      commonSessionStorage.setItem('ongoingActivitiesData', newList);
      return newList;
    } catch (e) {
      console.error('getOngoingActivities error:', e);
      return defaultList;
    }
  };
  
  if (type === 'distributor') {
    // 判断如果是在登录成功或者缓存的数据已经失效的情况重新调接口获取数据
    if (href.includes('ticket=') || !ongoingActivitiesData) {
      return getData(api.get_erpCommon_ymsActivityPlan_shopping);
    }
    return JSON.parse(JSON.stringify(ongoingActivitiesData));
  }
  return getData(api.get_ymsActivityPlan_shopping);
}

// 查询商城中已经启用的广告
export const getMallAdvertising = (type) => {
  let href = window.location.href;
  let mallAdvertising = store.state.mallAdvertising || commonSessionStorage.getItem('mallAdvertising');
  
  const getData = async (url) => {
    try {
      const response = await axios.get(url);
      if (response.data.code !== 0) return [];
      let data = response.data.datas || [];
      store.commit('mallAdvertising', data);
      commonSessionStorage.setItem('mallAdvertising', data);
      return data;
    } catch (e) {
      console.error('getMallAdvertising error:', e);
      return [];
    }
  };
  
  if (type === 'distributor') {
    // 判断如果是在登录成功或者缓存的数据已经失效的情况重新调接口获取数据
    if (href.includes('ticket=') || !mallAdvertising) {
      return getData(api.get_erpCommon_ymsAdvertisement_shopping);
    }
    return JSON.parse(JSON.stringify(mallAdvertising));
  }
  return getData(api.get_ymsAdvertisement_shopping);
}

// 获取币种基础数据
export const getCurrencyData = () => {
  return new Promise(resolve => {
    let newData = commonLocalStorage.getItem('currencyData') || [];
    if (newData.length > 0) {
      resolve(newData);
    } else {
      axios.get(api.get_currencyInfo + '?time=' + new Date().getTime()).then(response => {
        let data = response.data.datas || [];
        if (data.length > 0) {
          data.forEach((item) => {
            let label = item.currencyCode;
            if (item.currencyCnName) {
              label = label + '-' + item.currencyCnName;
            }
            item.label = label;
            item.value = item.currencyCode;
          })
        }
        commonLocalStorage.setItem('currencyData', data);
        resolve(data);
      }).catch((e) => {
        console.error('getCurrencyData error:', e);
        resolve([]);
      });
    }
  });
}

// 校验当前的字符串是否json格式的字符串
export const isJSON = (str) => {
  if (typeof str == 'string') {
    try {
      let obj = JSON.parse(str);
      return !!(typeof obj == 'object' && obj);
    } catch (e) {
      return false;
    }
  }
}

// 处理url参数
export const qs = (params) => {
  let str = '';
  for (let key in params) {
    str += key + '=' + params[key] + '&';
  }
  return str.slice(0, -1);
};

/**
 * 金额加法计算
 * @date: 2022/3/17 10:07
 * @param args 需要计算的金额
 */
export const amountAddition = (...args) => {
  let arr = [];
  let dotLength = 0;
  args.forEach(i => {
    if (i) {
      if (!isNaN(Number(i)) && i.toString().includes('.') && Math.pow(10, i.toString().split('.')[1].length) > dotLength) {
        dotLength = Math.pow(10, i.toString().split('.')[1].length);
      }
    }
  });
  args.forEach(i => {
    if (i) {
      if (dotLength > 0) {
        arr.push(i * dotLength);
      } else {
        arr.push(i);
      }
    }
  });
  let amount = arr.reduce((a, b) => {
    return a + b;
  }, 0);
  if (dotLength > 0) {
    return (amount / dotLength).toFixed(2);
  } else {
    return amount.toFixed(2);
  }
};

/**
 * 金额处理全局函数
 * @date: 2022/3/17 9:13
 * @param amount 金额 string number
 * @param number 保留的位数
 */
export const amountHandel = (amount, number = 2) => {
  if (isNaN(Number(amount))) {
    return 0;
  } else {
    return Number(amount).toFixed(number);
  }
};

/**
 * 菜鸟打印
 * @param   postID  packageId
 * @param  cainiaoData 打印内容
 * */
export const cainiaoPrint = (websocket, postID, cainiaoData) => {
  return new Promise(resolve => {
    websocket.onmessage = function (event) {
      let data = JSON.parse(event.data);
      let status = data['status'];
      if (typeof status !== 'undefined' && status === 'success') {
        resolve(data);
      } else if (typeof status !== 'undefined') {
      }
    };
    let arr = cainiaoData.split('|');
    let contents = [];
    for (let i = 0; i < arr.length; i++) {
      contents.push(JSON.parse(arr[i]));
    }
    let content = {
      cmd: 'print', requestID: new Date().getTime() + '', // 随机数
      version: '1.0', task: {
        taskID: new Date().getTime() + '', // 随机数
        preview: false, documents: [{
          contents: contents, documentID: postID // postID
        }]
      }
    };
    // 连接成功建立的回调方法
    websocket.send(JSON.stringify(content));
  });
};

// 判断当前浏览器是否支持WebSocket
export const initCainiao = () => {
  let websocket;
  if ('WebSocket' in window) {
    websocket = new WebSocket('ws://127.0.0.1:13528');
  } else {
    Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001648'));
  }
  // 连接发生错误的回调方法
  websocket.onerror = function () {
    Message.info(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001649'));
  };
  return new Promise(resolve => {
    websocket.onopen = function () {
      resolve(websocket);
    };
  });
};

// 获取供应商id
export const getDistributorId = (domain) => {
  return new Promise(resolve => {
    domain = domain.includes('localhost') ? 'https://shop000817-test.pvt.yms.com' : domain;
    axios.get(api.get_ymsSupplierMerchant_getYmsMerchantByDomain + '?supplierWebDomain=' + domain).then((response) => {
      if (response.data.code === 0) {
        store.commit('distributorInfo', response.data.datas);
        localStorage.setItem('distributorInfo', JSON.stringify(response.data.datas))
        resolve(true);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('getDistributorId error:', e);
      resolve(false);
    });
  });
};

// 数据埋点
export const webDataCollectionFn = () => {
  try {
    if (!window.webDataCollection) {
      console.error('webDataCollection is undefined');
      return false;
    }
    let _mid = null;
    let _uid = null;
    let erpConfig = commonSessionStorage.getItem("erpConfig") || store.state.erpConfig;
    if (erpConfig) {
      _mid = erpConfig.userInfo.merchantId;
      _uid = erpConfig.userInfo.userId;
    }
    const currentKey = `${_mid || 'anonymous'}:${_uid || 'anonymous'}`;
    if (currentKey === webDataCollectionKey) {
      return true;
    }
    let reporter = new webDataCollection({
      bid: 'yms', // bid系统标识
      mid: _mid, // merchantId
      uid: function () {
        return _uid; // userId
      }, excludeUrl: [], //不需要上报的API地址，API接口地址包含以下内容将不会上报数据
      plugins: [[wpkinterfacePlugin, {
        withBody: true // 是否上报请求的body参数
      }]]
    });
    reporter.install();
    webDataCollectionKey = currentKey;
    return true;
  } catch (e) {
    console.error('webDataCollection init error:', e);
    return false;
  }
}
// 判断是否为 chunk load error
export const isChunkLoadError = (error) => {
  if (!error) return false;
  const {name = '', message = '', code = '', target = {}} = error;
  const src = target?.src || target?.href || '';
  return (
    // webpack
    name === 'ChunkLoadError'
    // webpack css
    || code === 'CSS_CHUNK_LOAD_FAILED'
    // vite / webpack 通用
    || /Loading (CSS )?chunk .* failed/i.test(message)
    // vite 动态 import
    || /Failed to fetch dynamically imported module/i.test(message)
    // safari
    || /Importing a module script failed/i.test(message)
    // firefox
    || /error loading dynamically imported module/i.test(message)
    // script load
    || /Loading module from .* was blocked/i.test(message)
    // webpack async chunk URL
    || /\/(js|css)\/chunk-.*\.(js|css)/i.test(error?.request || '')
    // target src/href 加载失败
    || /\/(js|css)\/chunk-.*\.(js|css)/i.test(src)
  );
}
// 显示页面初始化失败模态框
export const showPageInitFailureModal = (content = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001650')) => {
  if (pageInitFailureModalVisible) return;
  pageInitFailureModalVisible = true;
  Modal.confirm({
    title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
    content,
    okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001651'),
    closable: false,
    maskClosable: false,
    onOk: () => {
      pageInitFailureModalVisible = false;
      window.location.reload();
    },
    onCancel: () => {
      pageInitFailureModalVisible = false;
    }
  });
}

// 处理退出异常url ?#
export const errorUrlHandel = (url) => {
  return url.includes('?#') ? url.replace('?#', '#') : url;
};

// 获取商城地址
export const getShopDomain = () => {
  return new Promise(resolve => {
    axios.get(api.get_ymsCommon_shopping_baseInfo).then((response) => {
      if (response.data.code === 0) {
        store.commit('shoppingInfo', response.data.datas);
        resolve(true);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('getShopDomain error:', e);
      resolve(false);
    });
  });
};

// 判断当前供应商系统中是否存在待确认的账单
export const isBillConfirmed = (to) => {
  const {query = {}} = to || {};
  const newTicket = query.ticket;
  if (!newTicket) return;
  const oldTicket = commonSessionStorage.getItem('oldTicket');
  const isNewTicket = newTicket !== oldTicket;
  setTimeout(() => {
    // 只有在登录进来的时候，才调用
    if (!window.location.href.includes('ticket=') || !isNewTicket) return;
    const {isAdmin, roleData = []} = store.state;
    if (!isAdmin && !roleData.includes('supplier_reconciliationManage')) return;
    axios.get(api.get_ymsSupplierBill_waitConfirmSupplierBill).then(({data}) => {
      if (data?.code !== 0) return;
      const list = data.datas || [];
      commonSessionStorage.setItem('oldTicket', newTicket);
      if (list.length > 0) {
        showBillConfirmed();
      }
    });
  }, 1000);
};


// 根据ymsLogisServiceId批量获取云卖物流信息
export const getYmsLogisServiceData = (ymsLogisServiceIdsList) => {
  return new Promise(resolve => {
    axios.post(api.post_ymsLogisService_queryByIds, ymsLogisServiceIdsList).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
      } else {
        resolve(true);
      }
    }).catch((e) => {
      console.error('getYmsLogisServiceData error:', e);
      resolve(true);
    });
  });
}

// 根据邮寄方式流水号查询供应商物流渠道信息
export const getSupplierLogisticsData = (supplierShippingMethodIds) => {
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.post_ymsCarrierShippingMethod_querySupplierOwnShippingMethod :
    api.post_ymsCarrierShippingMethod_api_querySupplierOwnShippingMethod;
  return new Promise(resolve => {
    axios.post(url, supplierShippingMethodIds).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
      } else {
        resolve(true);
      }
    }).catch((e) => {
      console.error('getSupplierLogisticsData error:', e);
      resolve(true);
    });
  });
}

// 自有物流渠道适用范围数据
export const getOwnLogisticsChannel = () => {
  return new Promise(resolve => {
    axios.get(api.get_ymsCarrier_queryDistributorEnableCarrier).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getOwnLogisticsChannel error:', e);
      resolve([]);
    });
  });
}

// 处理平台图片、logo数据
export const handleImagesData = (data) => {
  if (data.length > 0) {
    data.map((item) => {
      let images = item.images || [];
      if (images.length > 0) {
        images.map((ele) => {
          switch (ele.size) {
            case '64x64':
              item.iconPath = ele.imagePath;
              break;
            case '107x42':
              item.logoPath = ele.imagePath;
              break;
          }
        })
      }
    });
  }
  return data;
}

/**
 * @Description: 根据币种显示具体的 默认返回 币种+币种名称
 * @params: currency 币种   value 需要展示的字段
 */
export const currencyNameCode = (currency, value) => {
  let currencyData = commonLocalStorage.getItem('currencyData') || [];
  let currencyName = '';
  if (currencyData.length > 0) {
    currencyData.map((item) => {
      if (item.currencyCode === currency) {
        if (value) {
          currencyName = item[value]
        } else {
          currencyName = item.currencyCnName + ' ' + item.currencyCode
        }
      }
    });
  }
  return currencyName;
}

/**
 * @Description: 根据仓库id获取库区数据
 * @params: ymsWarehouseId 仓库id
 * @params: system 系统标识  yms 运营系统  distributor 分销系统  supplier 供应商系统
 */
export const getYmsWarehouseBlockList = (ymsWarehouseId, system = 'yms') => {
  if (!ymsWarehouseId) return Promise.resolve([]);
  const urlMap = {
    yms: api.get_ymsWarehouseBlock_queryByYmsWarehouesId,
    supplier: api.get_ymsWarehouseBlock_api_queryByYmsWarehouseId
  };
  const url = urlMap[system];
  if (!url) return Promise.resolve([]);
  return axios.get(url, {params: {ymsWarehouseId}}).then(({data}) => (data?.code === 0 ? data.datas || [] : [])).catch(() => []);
};


export {setConfigCharacters};

// 判断当前商户是否是阿里国际分销商
export const isAlibabaDistributor = () => {
  let talg = false;
  let obj = commonSessionStorage.getItem('erpConfig');
  if (obj) {
    let ymsSite = obj.ymsSite || null;
    if (ymsSite) {
      talg = ymsSite.merchantType === 'ALIGJ'
    }
  }
  commonSessionStorage.setItem('isAlibabaSite', talg);
  window.dispatchEvent(new Event('isAlibabaSiteUpdated'));
  return talg;
}

// 是阿里国际分销，需要过滤掉相关菜单
export const hideAlibabaDistributorsMenuData = (menuData) => {
  
  function handleData(menuData, distributorType) {
    const result = [];
    for (let i = 0; i < menuData.length; i++) {
      const item = menuData[i];
      let newItem = {...item};
      if (newItem.children && newItem.children.length > 0) {
        newItem.children = handleData(newItem.children, distributorType); // 递归处理 children
        if (newItem.children.length > 0) {
          result.push(newItem);
        }
      } else if (newItem.distributorType && newItem.distributorType.includes(distributorType)) {
        result.push(newItem);
      }
    }
    return result;
  }
  
  if (isAlibabaDistributor()) {
    return handleData(menuData, 'ALIGJ');
  } else {
    return handleData(menuData, 'YMS');
  }
}

// 获取运营系统所有站点的数据
export const getYmsSiteData = (query) => {
  const systemType = getSystemType();
  return new Promise((resolve) => {
    let url;
    if (query) {
      url = api.get_ymsSite_api_query + query;
    } else {
      let val = "?time=" + new Date().getTime();
      url = systemType === 'yms' ? api.get_ymsSite_queryAll + val : api.get_ymsSite_api_query + val
    }
    axios.get(url).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getYmsSiteData error:', e);
      resolve([]);
    });
  })
}

// 复制内容的公共方法
export const commonCopyContent = (content, text) => {
  return new Promise(resolve => {
    let oInput = document.createElement('textarea');
    oInput.value = content;
    document.body.appendChild(oInput);
    oInput.select();
    window.document.execCommand('Copy');
    oInput.remove();
    if (text) {
      Message.success(text);
    }
    resolve();
  });
}

/**
 * @Description: 通过后缀判断是否是图片
 * @params: fileName 文件/链接路径
 */
export const isImageFile = (fileName) => {
  const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg', '.ico'];
  const fileExtension = fileName.toLowerCase().substr(fileName.lastIndexOf('.'));
  return imageExtensions.includes(fileExtension);
}

// 通过域名获取当前站点信息
export const getDomainSiteInfo = (domainName) => {
  const getHostname = (url) => {
    if (!url) return '';
    return url.replace(regular.matchHttpHttps, '').replace(/\/$/, '');
  };
  let siteDomain = '';
  if (domainName) {
    siteDomain = getHostname(domainName);
  } else if (window.location.hostname.includes('localhost')) {
    const target = proxyFile['/']?.target || '';
    siteDomain = getHostname(target);
  } else {
    siteDomain = window.location.hostname;
  }
  return getYmsSiteData(`?siteDomain=${siteDomain}`).then(data => data || []);
};


// 获取当前系统配置的域名数据
export const getSystemDomainNameData = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsBase_info_query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve({});
    }).catch((e) => {
      console.error('getSystemDomainNameData error:', e);
      resolve({});
    });
  });
}

/**
 * @Description: 根据分类id批量查询类目信息
 * @params:
 * originalData 列表数据
 * url 请求接口
 * ymsProductCategoryIds 分类id集合
 * returnTalg 是否需要返回原始数据，false 默认不返回，true返回原始数据
 */
export const getBatchCategoryInfoData = (url, originalData, ymsProductCategoryIds, returnTalg = false) => {
  return new Promise((resolve) => {
    axios.post(url, ymsProductCategoryIds).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        if (returnTalg) {
          resolve(data);
        } else {
          originalData.map((item) => {
            item['classificationName'] = '-';
            data.map((ele) => {
              if (item.ymsProductCategoryId === ele.ymsProductCategoryId) {
                let txt = ele.productCategoryNavigation.split('->');
                let name = txt.join(' / ');
                item['classificationName'] = name;
              }
            })
          });
          resolve(originalData);
        }
        return;
      }
      resolve(returnTalg ? [] : originalData);
    }).catch((e) => {
      console.error('getBatchCategoryInfoData error:', e);
      resolve(returnTalg ? [] : originalData);
    });
  })
}

/**
 * @Description: 根据商户号、用户id获取ticket的公共方法
 * @params: userId、merchantId
 */
export const getCommonTicket = (query, value) => {
  return new Promise(resolve => {
    axios.post(api.post_createTicket, query, {loading: value}).then((response) => {
      if (response.data.code === 0) {
        resolve(response.data.datas);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('getCommonTicket error:', e);
      resolve(false);
    });
  });
}

/**
 * @Description: 处理上传图片的地址（上传图片成功之后自动拼接完整的全路径）
 * @params: 例：http://admin-test.pvt.yms.com/yms-supplier-service/filenode/s/temp/yms-supplier-service/000815/2024-07-15/b3505bd690bb4628bd6c92d06aaf5e23.jpg
 */
export const handleUploadImageAddress = (tempUrl = '') => {
  if (!tempUrl) return '';
  const systemType = getSystemType();
  const service = SERVICE_MAP[systemType] || '';
  const erpConfig = commonSessionStorage.getItem('erpConfig') || this.$store.state.erpConfig;
  if (!erpConfig?.filenodeViewTargetUrl) return '';
  const filenodePath = erpConfig.filenodeViewTargetUrl.split('.')[1];
  const isLocalhost = window.location.hostname.includes('localhost');
  const baseUrl = isLocalhost ? proxyFile['/']?.target?.replace(/\/$/, '') : window.location.origin;
  return `${baseUrl}${service}${filenodePath}${tempUrl}`;
};


// base64 转 Blob 对象
export const base64ToBlob = (base64) => {
  return new Promise((resolve, reject) => {
    try {
      const byteCharacters = atob(base64.split(',')[1]);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const mime = base64.split(',')[0].split(':')[1].split(';')[0];
      const blob = new Blob([byteArray], {type: mime});
      resolve(blob);
    } catch (error) {
      reject(error);
    }
  })
}

// base64 转 File 对象
export const base64ToFile = (base64, fileName) => {
  return base64ToBlob(base64).then((blob) => {
    // 获取文件类型
    const mimeString = base64.split(',')[0].split(':')[1].split(';')[0];
    // 创建一个File对象
    const file = new File([blob], fileName, {type: mimeString});
    return file;
  })
}

// 查询商户下拥有所有授权仓库的用户
export const getYmsUserWarehouseOpersUserName = (userId) => {
  return new Promise(resolve => {
    axios.get(api.get_ymsCoreUserInfo_getYmsUserWarehouseOpers + userId).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve({});
    }).catch((e) => {
      console.error('getYmsUserWarehouseOpersUserName error:', e);
      resolve({});
    });
  });
}

// 获取商品标签所有数据
export const getAllProductLabelData = () => {
  const systemType = getSystemType();
  return new Promise(resolve => {
    let url = '';
    if (systemType === 'yms') {
      url = api.get_ymsProductTag_queryAllList;
    } else {
      url = api.get_ymsProductTag_api_queryProductTagList;
    }
    axios.get(url).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        data.map((item) => {
          let obj = JSON.parse(item.name);
          for (let key in obj) {
            item['productLabel_' + key] = obj[key] || obj[defaultLanguages];
          }
        })
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getAllProductLabelData error:', e);
      resolve([]);
    });
  });
}

// 账户余额不足相关提示
export const insufficientAccountBalance = (v) => {
  let configurationItemInfo = commonLocalStorage.getItem('configurationItemInfo') || store.state.configurationItemInfo;
  let onlineBalanceRecharge = configurationItemInfo?.onlineBalanceRecharge || false;
  if (onlineBalanceRecharge) {
    Modal.confirm({
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001652'),
      content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001653'),
      okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001654'),
      cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
      onOk: () => {
        const {href} = v.$router.resolve({
          name: 'RechargeRecord'
        });
        localStorage.setItem('openRechargeTalg', JSON.stringify(true));
        window.open(href, '_blank');
      },
      onCancel: () => {
      }
    })
  } else {
    Modal.warning({
      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001652'),
      content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001655'),
      okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
    })
  }
}

/**
 * @Description: 通过paramKeys获取对应paramValue设置的公共接口
 * @params:
 * businessId: 支持用户级别、商户级别
 * paramKeys：对应设置的key
 * isParamValue：是否直接返回paramValue值
 */
export const getCommonParamKeysData = (businessId, paramKeys, isParamValue = false, system) => {
  const systemType = getSystemType();
  return new Promise(resolve => {
    let query = {
      businessId: businessId,
      paramKeys: paramKeys
    }
    let url = '';
    if (system) {
      url = api.post_erpCommonSettingParam_queryByUK;
    } else {
      url = systemType === 'yms' ? api.post_erpCommonSettingParam_queryByUK : api.post_erpCommonSettingParam_api_queryByUK;
    }
    axios.post(url, query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        if (isParamValue) {
          if (data.length > 0) {
            for (const item of data) {
              if (paramKeys.includes(item.paramKey)) {
                resolve(isJSON(item.paramValue) ? JSON.parse(item.paramValue) : item.paramValue);
                return;
              }
            }
          }
          resolve(false);
          return;
        }
        resolve(data);
        return;
      }
      resolve(isParamValue ? false : []);
    }).catch((e) => {
      console.error('getCommonParamKeysData error:', e);
      resolve(isParamValue ? false : []);
    });
  });
}

/**
 * @Description: 获取Saas系统配置的可选值数据
 * @author jing
 * @date 2026/4/3 13:50
 * @params: updateValue 是否强制更新
 */
export const getSaasParamKeysData = async (updateValue = false) => {
  // 商户入驻页不依赖 SaaS 配置，跳过接口请求
  if ((window.location.hash || '').includes('/merchantSettlement')) {
    return {};
  }
  const shouldRequest = updateValue || window.location.href.includes('ticket=');
  if (!shouldRequest) return {};
  try {
    const {data} = await axios.post(api.post_erpCommonSettingParam_querySaasByParamKeys, SAAS_PARAM_KEYS);
    if (data.code !== 0) return {};
    let obj = (data.datas || []).reduce((acc, item) => {
      let value = item.paramValue;
      if (isJSON(value)) {
        value = JSON.parse(value);
      }
      if (SAAS_PARAM_KEYS.includes(item.paramKey)) {
        acc[item.paramKey] = value;
      }
      return acc;
    }, {});
    store.commit('saasConfigurationItems', obj)
    commonLocalStorage.setItem('saasConfigurationItems', obj);
    return obj;
  } catch (e) {
    console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001656'), e);
    return {};
  }
};

// 同一次页面生命周期内只强制拉取一次 SaaS 配置，避免路由切换重复请求
let saasParamKeysFetched = false;

// 是否为浏览器整页刷新进入
export const isReloadNavigation = () => {
  const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
  return navigationEntry?.type === 'reload';
};

// 登录成功或整页刷新时拉取 SaaS 配置（须在 token 就绪后调用）
export const ensureSaasParamKeysData = async (to, justLoggedIn) => {
  const hasTicket = !!(to.query && to.query.ticket);
  const needFetch = justLoggedIn || hasTicket || (isReloadNavigation() && !saasParamKeysFetched);
  if (!needFetch || saasParamKeysFetched) {
    return;
  }
  saasParamKeysFetched = true;
  await getSaasParamKeysData(true);
};

// 压缩图片 base64
export function compressImage(file, quality = 0.7) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const maxWidth = 100;
        const maxHeight = 100;
        let width = img.width;
        let height = img.height;
        if (width > height && width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        } else if (height > width && height > maxHeight) {
          width = (maxHeight / height) * width;
          height = maxHeight;
        }
        canvas.width = width;
        canvas.height = height;
        ctx.drawImage(img, 0, 0, width, height);
        const base64Data = canvas.toDataURL(file.type, quality);
        resolve(base64Data);
      };
      img.src = event.target.result;
    };
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
}

// 获取所有支付渠道数据
export const getPaymentChannelsData = (status) => {
  return new Promise(resolve => {
    let url = api.get_ymsReceivePayAccount_queryAll;
    if (status) {
      url = url + status;
    }
    axios.get(url).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getPaymentChannelsData error:', e);
      resolve([]);
    });
  });
}

// 支付币种转换
export const getCurrencyConversion = (query) => {
  return new Promise(resolve => {
    axios.post(api.post_ymsCommon_api_conversionPayPrice, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve(null);
    }).catch((e) => {
      console.error('getCurrencyConversion error:', e);
      resolve(null);
    });
  });
}

/**
 * @Description: 通过paramKeys自定义设置获取对应paramValue设置的公共接口
 * @params:
 * businessId: 支持用户级别、商户级别
 * paramKeys：对应设置的key
 * isParamValue：是否直接返回paramValue值
 */
export const getqueryByParamKeysData = (query, paramKeys, isParamValue = false) => {
  const systemType = getSystemType();
  return new Promise(resolve => {
    let url = systemType === 'yms' ? api.post_erpCommonSettingParam_queryByParam : api.post_erpCommonSettingParam_api_queryByParam;
    axios.post(url, query, {loading: true}).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        if (isParamValue) {
          if (data.length > 0) {
            data.map((item) => {
              if (paramKeys.includes(item.paramKey)) {
                resolve(item.paramValue);
                return;
              }
            })
          } else {
            resolve(false);
            return;
          }
        } else {
          resolve(data);
          return;
        }
        resolve(false);
        return;
      }
      resolve(isParamValue ? false : []);
    }).catch((e) => {
      console.error('getqueryByParamKeysData error:', e);
      resolve(isParamValue ? false : []);
    });
  });
}

// 处理所有国家数据按照洲区分类
export const handleCountryContinentData = (countries) => {
  const continentMapping = {
    Oceania: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001657'), continent: 'Oceania', twoCode: 'Oceania', children: []},
    Europe: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001658'), continent: 'Europe', twoCode: 'Europe', children: []},
    Asia: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001659'), continent: 'Asia', twoCode: 'Asia', children: []},
    Antarctic: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001660'), continent: 'Antarctic', twoCode: 'Antarctic', children: []},
    Americas: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001661'), continent: 'Americas', twoCode: 'Americas', children: []},
    Africa: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001662'), continent: 'Africa', twoCode: 'Africa', children: []},
    other: {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000363'), continent: 'other', twoCode: 'other', children: []}
  };
  
  // 遍历国家数据并填充大洲对象的 children
  countries.forEach(country => {
    const continent = continentMapping[country.continent];
    if (continent) {
      const {cnName, ...otherFields} = country; // 解构国家，删除 cnName
      continent.children.push({
        ...otherFields,
        title: cnName
      });
    }
  });
  // 返回只包含非空的洲信息
  return Object.values(continentMapping).filter(({children}) => children.length > 0);
}

/**
 * @Description:  根据返回国家twoCode 获取所在国家对应的洲名称或者国家名称或者 获取所在国家对应洲的twoCode值
 * @params:
 * selectedCountryCodes 当前选中的国家code
 * countryCodeData 所有国家数据
 * returnType: name 获取名称    code 获取code值
 */
export const getNationalContinentName = (selectedCountryCodes, countryCodeData, returnType = 'name') => {
  // 生成国家地图
  const buildCountriesMap = (countries) => {
    const map = {};
    countries.forEach(country => {
      // 添加顶级国家
      map[country.twoCode] = {
        continent: country.continent,
        isChild: false,
        name: country.title || country.name,
        twoCode: country.twoCode,
        children: country.children ? country.children.map(child => child.twoCode) : []
      };
      // 添加子项
      (country.children || []).forEach(child => {
        map[child.twoCode] = {
          continent: country.continent,
          isChild: true,
          name: child.title || child.name,
          twoCode: child.twoCode
        };
      });
    });
    return map;
  };
  
  const countriesMap = buildCountriesMap(countryCodeData);
  const continentMap = {};
  selectedCountryCodes.forEach(countryCode => {
    const countryInfo = countriesMap[countryCode];
    if (countryInfo) {
      const continent = countryInfo.continent;
      // 初始化洲分类
      continentMap[continent] = continentMap[continent] || {
        continentName: continent,
        countries: []
      };
      continentMap[continent].countries.push(returnType === 'code' ? countryInfo.twoCode : countryInfo.name);
    }
  });
  
  const resultList = [];
  for (const continent in continentMap) {
    const {continentName, countries} = continentMap[continent];
    // 如果选择了所有子项，返回洲的名称
    const allChildren = countriesMap[continentName]?.children || [];
    if (countries.length === allChildren.length) {
      const continentInfo = countryCodeData.find(item => item.twoCode === continentName);
      if (continentInfo) {
        resultList.push(returnType === 'code' ? continentInfo.twoCode : continentInfo.title || continentInfo.name);
      }
    } else {
      resultList.push(...new Set(countries));
    }
  }
  return resultList.length > 0 ? [...new Set(resultList)] : selectedCountryCodes.map(code => countriesMap[code]?.[returnType] || code);
};

// 获取所有发货地数据
export const getDeliveryAreasAllData = (value) => {
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.get_ymsDeliveryPlace_queryList : api.get_ymsDeliveryPlace_api_query;
  return new Promise(resolve => {
    axios.get(url).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        if (value === 'listing') {
          commonLocalStorage.setItem('deliveryLocationData', data);
          if (data.length > 0) {
            commonLocalStorage.setItem('ymsDeliveryPlaceId', data[0].ymsDeliveryPlaceId);
          }
        }
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getDeliveryAreasAllData error:', e);
      resolve([]);
    });
  });
};

/**
 * @Description: 根据id批量获取发货地名称
 * @params:  ymsDeliveryPlaceIdList  发货地id
 */
export const getBatchDeliveryAreasName = (ymsDeliveryPlaceIdList) => {
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.post_ymsDeliveryPlace_queryByIds : api.post_ymsDeliveryPlace_api_queryByIds;
  return new Promise(resolve => {
    axios.post(url, ymsDeliveryPlaceIdList).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getBatchDeliveryAreasName error:', e);
      resolve([]);
    });
  });
};

// 获取发货地与国家信息的数据集合
export const getPlaceOfShipmentCountryData = (type) => {
  const systemType = getSystemType();
  return new Promise(resolve => {
    let url = '';
    switch (systemType) {
      case 'yms':
        let obj = {
          platformWarehouse: 'core',
          supplierWarehouse: 'supplier',
        }
        url = api.get_ymsWarehouse_queryDeliveryAndCountry + obj[type];
        break;
      case 'supplier':
        url = api.get_wmsWarehouse_queryDeliveryAndCountry;
        break;
      case 'distributor':
        url = api.get_ymsDistributorWarehouse_queryDeliveryAndCountry;
        break;
    }
    axios.get(url).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getPlaceOfShipmentCountryData error:', e);
      resolve([]);
    });
  });
}

// 批量查询供应商仓库信息
export const getBatchSupplierWarehouseData = async (supplierMerchantIds) => {
  const systemType = getSystemType();
  try {
    const {data: res} = await axios.post(api.post_ymsWarehouse_api_queryBySuppliers, supplierMerchantIds);
    if (res.code !== 0) {
      return [];
    }
    return (res.datas || []).reduce((list, item) => {
      // 是否有供货仓配置
      const isCollectionWarehouseTalg = item.isCollectionWarehouse === 1 && (item.ymsWarehouseCollectionSettings?.length || 0) > 0;
      // 是否有直发仓配置
      const isDeliveryWarehouseTalg = item.isDeliveryWarehouse === 1 && (item.ymsWarehouseDeliverySettings?.length || 0) > 0;
      if (!isCollectionWarehouseTalg && !isDeliveryWarehouseTalg) {
        return list;
      }
      list.push({
        ...item,
        name: systemType === 'supplier' ? item.name : (item.aliasWarehouseName || item.name),
        warehouseTypeName: isCollectionWarehouseTalg && isDeliveryWarehouseTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001663') :
          isCollectionWarehouseTalg ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001664') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001665'),
        isCollectionWarehouseTalg,
        isDeliveryWarehouseTalg,
        targetWarehouseCountryList: isCollectionWarehouseTalg ? item.ymsWarehouseCollectionSettings.map(({countryCode}) => countryCode) : []
      });
      return list;
    }, []);
  } catch (e) {
    console.error('getBatchSupplierWarehouseData error:', e);
    return [];
  }
};

// 获取供应商订单详情信息
export const getSupplierOrderDetailData = (loading, packageId) => {
  return new Promise((resolve) => {
    axios.get(api.get_packageInfo + packageId, {loading: loading, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || {};
        resolve(data);
        return;
      }
      resolve({});
    }).catch((e) => {
      console.error('getSupplierOrderDetailData error:', e);
      resolve({});
    });
  });
}

/**
 * @Description: 币种汇率转换
 * @params:
 * @param {Number} amount 金额，基准币种数量，比如 1 CNY
 * @param {String} toCurrency 目标币种代码，比如 'USD'
 * @param {Object} rates 汇率对象，key为币种代码
 * @returns {Number|null} 换算后的金额，保留4位小数，无数据返回null
 */
export const convertCurrency = (amount, toCurrency, rates) => {
  if (rates[toCurrency]) {
    const convertedAmount = amount / rates[toCurrency];
    return convertedAmount.toFixed(4);
  } else {
    return 0;
  }
}

// 获取目标集货中心仓的数据
export const getStoreGoodsData = (countrysList) => {
  let nationalSupplyPriceData = [];
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.get_ymsWarehouse_queryByCoreWarehouse : api.get_ymsWarehouse_api_queryByCoreWarehouse;
  return new Promise((resolve) => {
    axios.get(url).then((response) => {
      let data = response.data.datas || [];
      const newList = data
        .flatMap(warehouse => warehouse.ymsWarehouseAddress || [])
        .filter(address => address.addressType === 'sender')
        .map(address => address.countryCode)
        .filter((code, index, arr) => arr.indexOf(code) === index);
      if (newList.length > 0) {
        countrysList.map((item) => {
          if (newList.includes(item.twoCode)) {
            nationalSupplyPriceData.push({
              countryName: item.cnName,
              ...item
            })
          }
        })
      }
      resolve(nationalSupplyPriceData)
    }).catch((e) => {
      console.error('getStoreGoodsData error:', e);
      resolve([]);
    });
  })
}

// 根据仓库ID批量获取仓库信息数据
export const batchAllWarehouseData = async (ymsWarehouseIds) => {
  const systemType = getSystemType();
  try {
    const {data: res} = await axios.post(api.post_ymsWarehouse_api_queryByIds, ymsWarehouseIds);
    if (res.code !== 0) {
      return [];
    }
    const data = res.datas || [];
    data.forEach(item => {
      item.name = systemType === 'supplier' ? item.name : (item.aliasWarehouseName || item.name);
    });
    return data;
  } catch (e) {
    console.error('batchAllWarehouseData error:', e);
    return [];
  }
};

/**
 * @Description: 获取所有仓库数据（平台仓、供应商仓） retrieveAllWarehouseData
 * @params:
 * code: string 编码
 * collectionWarehouse: 0 否 1 是 （是否为集货仓）
 * countryCode: string 国家
 * isCollectionWarehouse: 0 否 1 是 （是否是供货仓）
 * isDeliveryWarehouse: 0 否 1 是 （是否是直发仓）
 * name: string 名称
 * orderBy: string 排序方式
 * orderSeq: string 排序
 * supplierMerchantIds：指定商户
 * status: 0 正常 1 禁用 （仓库状态）
 * stockedWarehouse: 0 否 1 是 （是否能备货）
 * supplierMerchantSearch: string 所属供应商
 * servicePlatform: core 平台仓 supplier 供应商仓
 * servicePlatforms: core 平台仓 / supplier 供应商仓 （数组，多个值）
 * ymsDeliveryPlaceId: string 发货地
 * warehouseIds: [] // 仓库id
 */
export const getAllWarehouseData = async (params) => {
  const systemType = getSystemType();
  try {
    const {data: res} = await axios.post(api.post_ymsWarehouse_api_queryList, params);
    if (res.code !== 0) {
      return [];
    }
    const data = res.datas || [];
    data.forEach(item => {
      item.name = systemType === 'supplier' ? item.name : (item.aliasWarehouseName || item.name);
    });
    return data;
  } catch (e) {
    console.error('getAllWarehouseData error:', e);
    return [];
  }
};

/**
 * @Description: 根据货品ID批量获取商品发货仓及库存
 * @params: ymsProductGoodsIds
 */
export const getProductShippingWarehouseInventory = async (ymsProductGoodsIds) => {
  try {
    const {data: res} = await axios.post(api.post_ymsPlatformOrder_queryDeliverWarehouse, ymsProductGoodsIds);
    if (res.code !== 0) {
      return [];
    }
    const data = res.datas || [];
    data.forEach(item => {
      item.productDeliverWarehouseResultBos?.forEach(ele => {
        ele.name = ele.aliasWarehouseName || ele.name;
      });
    });
    return data;
  } catch (e) {
    console.error('getProductShippingWarehouseInventory error:', e);
    return [];
  }
};

// 获取所有云卖物流
export const getYunLogisticsAllData = () => {
  return new Promise((resolve) => {
    let query = {
      name: null,
      carrierId: null,
      shippingMethodId: null,
      status: null,
      merchantType: null,
      language: null
    };
    axios.post(api.post_ymsLogisService_api_queryList, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getYunLogisticsAllData error:', e);
      resolve([]);
    });
  });
}

// 批量获取所有有效的物流及运输方式-->匹配物流下拉框数据（自有物流+YMS物流+供应商物流）
export const getAllMatchingLogisticsData = (query, type) => {
  let newData = [];
  // 自有物流
  const _getSelfOwnedLogistics = (data) => {
    let newList = [];
    if (data.length > 0) {
      data.map((item) => {
        if (item.queryYmsCarrierShippingMethodBoList) {
          item.queryYmsCarrierShippingMethodBoList.map((ele) => {
            let carrierShippingMethodName = _handleMultilingualFields(ele.carrierShippingMethodName);
            newList.push({
              ...ele,
              coreCarrierId: item.coreCarrierId,
              name: item.carrierName + ' / ' + carrierShippingMethodName,
              ymsLogisServiceId: 'CID' + ele.shippingMethodId,
              code: ele.carrierShippingMethodCode,
              carrierShippingMethodName: carrierShippingMethodName,
              carrierMerchantType: 2, // 物流归属商户 1 供应商  2 分销商  3 运营
            })
          })
        }
      });
    }
    let list = newList.length > 0 ? uniqueByField(newList, 'ymsLogisServiceId') : [];
    return list;
  }
  // 供应商物流
  const _getSupplierLogistics = (data) => {
    let newList = [];
    if (data.length > 0) {
      data.map((item) => {
        if (item.carrierShippingMethods) {
          item.carrierShippingMethods.map((ele) => {
            let carrierShippingMethodName = _handleMultilingualFields(ele.carrierShippingMethodName);
            newList.push({
              ...ele,
              name: item.carrierName + ' / ' + carrierShippingMethodName,
              ymsLogisServiceId: 'CID' + ele.shippingMethodId,
              code: ele.carrierShippingMethodCode,
              carrierShippingMethodName: carrierShippingMethodName,
              carrierMerchantType: 1, // 物流归属商户 1 供应商  2 分销商  3 运营
            })
          })
        }
      });
    }
    let list = newList.length > 0 ? uniqueByField(newList, 'ymsLogisServiceId') : [];
    return list;
  }
  // 云卖物流
  const _getYmsLogistics = (data) => {
    let newList = [];
    if (data.length > 0) {
      data.map((item) => {
        newList.push({
          ...item,
          carrierShippingMethodName: item.name,
          carrierMerchantType: 3, // 物流归属商户 1 供应商  2 分销商  3 运营
        })
      });
    }
    let list = newList.length > 0 ? uniqueByField(newList, 'ymsLogisServiceId') : [];
    return list;
  }
  return new Promise((resolve) => {
    axios.post(api.post_ymsCarrierShippingMethod_queryAllEnableCarrierShippingMethod, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        data.map((item) => {
          let logisticsData = [
            {
              title: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581')}`,
              key: 'ymsEnableCarrier',
              list: _getYmsLogistics(item.ymsLogisServiceList || [])
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001587'),
              key: 'distributorEnableCarrier',
              list: _getSelfOwnedLogistics(type === 'distributorCarrier' ? (item.distributorCarrier || []) : (item.distributorEnableCarrier || [])),
              carrierData: (type === 'distributorCarrier' ? (item.distributorCarrier || []) : (item.distributorEnableCarrier || [])).map((ele) => {
                return {
                  ...ele,
                  carrierShippingMethodList: ele.queryYmsCarrierShippingMethodBoList || []
                }
              })
            },
            {
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001666'),
              key: 'supplierEnableCarrier',
              list: _getSupplierLogistics(item.supplierEnableCarrier || []),
              carrierData: (item.supplierEnableCarrier || []).map((ele) => {
                return {
                  ...ele,
                  carrierShippingMethodList: ele.carrierShippingMethods || []
                }
              })
            }
          ];
          newData.push({
            ymsWarehouseId: item.warehouseId,
            logisticsData: logisticsData
          });
        });
        resolve(newData);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getAllMatchingLogisticsData error:', e);
      resolve([]);
    });
  })
}

/**
 * @Description: 多语种出参字段展示的统一处理
 * @params: fields  字段名
 */
export const _handleMultilingualFields = (fields, value) => {
  let text = "";
  const languagesVal = getSetLanguages();
  if (fields) {
    if (isJSON(fields)) {
      let obj = JSON.parse(fields);
      // 默认先按照当前配置的语种取值，取不到指定语种值就默取中文值，中文值没有就默认取原始值
      if (value) {
        text = obj[languagesVal] || obj[defaultLanguages] || "";
      } else {
        text = obj[languagesVal] || obj[defaultLanguages] || fields || "";
      }
    } else {
      text = fields;
    }
  }
  return text;
}

// 根据数组中的某个属性去重
export const uniqueByField = (arr, field) => arr.filter((item, index, self) => index === self.findIndex(t => t[field] === item[field]));

// 获取汇率转换
export const getConverter = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsExchangeRate_api).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve({});
    }).catch((e) => {
      console.error('getConverter error:', e);
      resolve({});
    })
  });
}

// 获取试算价格(仓库维度)
export const getTrialPrice = (query) => {
  return new Promise((resolve) => {
    axios.post(api.post_ymsProductInfo_api_priceTrial + '?fresh=KEEPNEW', query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        let talg = data.some((item) => {
          return item.isExistModel === 0
        });
        if (talg) {
          Modal.warning({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001667'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
          })
        }
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getTrialPrice error:', e);
      resolve([]);
    });
  })
}

// 获取试算价格（货品维度）
export const getTrialGoodsPrice = (options = {}) => {
  let {
    productGoodsList = [],
    queryList,
    original = false
  } = options;
  return new Promise((resolve) => {
    axios.post(api.post_ymsProductInfo_api_priceTrials + '?fresh=KEEPNEW', queryList).then(response => {
      if (response.data.code === 0) {
        let newData = response.data.datas || [];
        let talg = newData.some((item) => {
          return item.isExistModel === 0
        });
        if (talg) {
          Modal.warning({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000330'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001667'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316'),
          })
        }
        if (original) {
          resolve(newData);
        } else {
          productGoodsList.map((ele) => {
            newData.map((item) => {
              let ymsProductGoodsId = item.ymsProductGoodsIds[0];
              if (item.warehouseId === ele.ymsWarehouseId && ele.ymsProductGoodsId === ymsProductGoodsId) {
                let goodsPrice = item.goodsPrice || 0;
                ele.suggestPrice = (goodsPrice / ele.quantity);
                ele.unitPrice = (goodsPrice / ele.quantity);
                ele.subtotal = (ele.unitPrice * parseInt(ele.quantity))
              }
            });
          });
          resolve(productGoodsList);
        }
        return;
      }
      resolve(original ? [] : productGoodsList);
    }).catch((e) => {
      console.error('getTrialGoodsPrice error:', e);
      resolve(original ? [] : productGoodsList);
    })
  })
}

/**
 * @Description: 列表数据合并的公共方法
 * @params: colKeys 需要合并列字段   idField 数据合并的唯一标识
 */
export const getSpanMethod = (tableData, colKeys, idField, row, column, rowIndex, columnIndex) => {
  // colKeys 支持数组或者单个字符串
  if (!Array.isArray(colKeys)) {
    colKeys = [colKeys];
  }
  if (!colKeys.includes(column.key)) {
    return {rowspan: 1, colspan: 1};
  }
  const data = tableData;
  const currentId = row[idField];
  if (rowIndex === 0) {
    let spanCount = 1;
    for (let i = rowIndex + 1; i < data.length; i++) {
      if (data[i][idField] === currentId) {
        spanCount++;
      } else {
        break;
      }
    }
    return {rowspan: spanCount, colspan: 1};
  }
  if (data[rowIndex - 1][idField] === currentId) {
    return {rowspan: 0, colspan: 0};
  }
  let spanCount = 1;
  for (let i = rowIndex + 1; i < data.length; i++) {
    if (data[i][idField] === currentId) {
      spanCount++;
    } else {
      break;
    }
  }
  return {rowspan: spanCount, colspan: 1};
}

// 获取供应商仓库数据
export const getSupplierWarehouseData = (query) => {
  return new Promise((resolve) => {
    axios.post(api.post_wmsWarehouse_queryList, query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getSupplierWarehouseData error:', e);
      resolve([]);
    });
  });
}

/**
 * @Description: 获取所有已启用的中心仓数据
 * @params: status 1
 */
export const getEnableWarehouseData = async (status) => {
  try {
    const {data: res} = await axios.get(api.get_ymsWarehouse_queryWarehouse + status);
    if (res.code !== 0) {
      return [];
    }
    const warehouseMap = new Map();
    (res.datas || []).forEach(item => {
      if (item.servicePlatform !== 'core') {
        return;
      }
      item.name = item.aliasWarehouseName || item.name;
      if (!warehouseMap.has(item.ymsWarehouseId)) {
        warehouseMap.set(item.ymsWarehouseId, item);
      }
    });
    return [...warehouseMap.values()];
  } catch (e) {
    console.error('getEnableWarehouseData error:', e);
    return [];
  }
};

/**
 * @Description: 展示最大最小价格区间
 * @params:
 * 最小值 minValue
 * 最大值 maxValue
 * 保留的小数位数，默认保留两位小数 decimalPlaces
 */
export const getPriceCommonRange = (minValue, maxValue, decimalPlaces = 2) => {
  if (minValue != null && maxValue != null) {
    return minValue === maxValue ? `${minValue.toFixed(decimalPlaces)}` : `${minValue.toFixed(decimalPlaces)} ~ ${maxValue.toFixed(decimalPlaces)}`;
  }
  return minValue != null ? `${minValue.toFixed(decimalPlaces)}` : maxValue != null ? `${maxValue.toFixed(decimalPlaces)}` : '-';
}

// 获取IOSS税率数据
export const getIossTaxRateData = (type) => {
  return new Promise((resolve) => {
    const urlMap = {
      yms: api.get_ymsIossRateSetting_query,
      distributor: api.get_ymsIossRule_queryRateSetting
    };
    axios.get(urlMap[type]).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        if (type === "distributor") {
          data = data.filter(item => item.status === 1);
        }
        resolve(data);
      } else {
        resolve([]);
      }
    }).catch(() => {
      resolve([]);
    });
  });
}

// 1688找同款跳转
export const to1688ByImg = (imgUrl = "") => {
  window.open(`https://air.1688.com/app/1688-global/main-site-channel/landing-page.html?outImageAddress=${imgUrl}`, "_blank");
}

// 商城获取平台数据
export const getShoppingPlatformData = (platformIds = []) => {
  return new Promise((resolve) => {
    let query = {
      platformIds: platformIds,
      platformType: "sales"
    };
    axios.post(api.post_ymsPlatform_shopping_query, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        let newData = handleImagesData(data);
        resolve(newData);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getShoppingPlatformData error:', e);
      resolve([]);
    });
  });
}

// 校验类目是否有定制商品
export const verifyCategoryCustomizedProducts = (ymsProductCategoryId) => {
  const systemType = getSystemType();
  return new Promise((resolve) => {
    let url = systemType === 'yms' ? api.get_checkProductCustomization : api.get_ymsProductInfo_api_checkProductCustomization;
    axios.get(url + ymsProductCategoryId).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || 0;
        resolve(data);
        return;
      }
      resolve(0);
    }).catch((e) => {
      console.error('verifyCategoryCustomizedProducts error:', e);
      resolve(0);
    });
  })
}

// 处理logo图片的
export const handleLogoUrl = () => {
  let pageConfig = commonLocalStorage.getItem('pageConfig') || store.state.pageConfig;
  let tongtongLogo = require('@/assets/images/tongtool-logo.png');
  return pageConfig?.logoImg || tongtongLogo;
}

// 获取负责区域国家数据
export const getCountryZoneData = () => {
  const languagesVal = getSetLanguages();
  return new Promise((resolve) => {
    axios.get(api.get_ymsDistributorCountryZone_queryAll).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        let grouped = data.reduce((acc, item) => {
          if (!acc[item.zoneCode]) {
            acc[item.zoneCode] = {
              zoneCode: item.zoneCode,
              name: languagesVal === defaultLanguages ? item.cnName : item.enName,
              cnName: item.cnName,
              enName: item.enName,
              countries: [], // 存放所有 twoCode
            };
          }
          acc[item.zoneCode].countries.push(item.twoCode);
          return acc;
        }, {});
        let list = Object.values(grouped);
        resolve(list);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getCountryZoneData error:', e);
      resolve([]);
    });
  });
}

// 获取所有关联责任人的数据
export const getAllPersonInChargeData = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsCompliancePerson_queryAll).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data)
        return;
      }
      resolve([])
    }).catch((e) => {
      console.error('getAllPersonInChargeData error:', e);
      resolve([])
    });
  });
}

// 获取所有关联制造商的数据
export const getAllManufacturerData = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsManufacturerInfo_queryAll).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data)
        return;
      }
      resolve([])
    }).catch((e) => {
      console.error('getAllManufacturerData error:', e);
      resolve([])
    });
  });
}

// 获取收货地址数据
export const getReceivingAddressData = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsDeliveryAddress_query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data)
        return;
      }
      resolve([])
    }).catch((e) => {
      console.error('getReceivingAddressData error:', e);
      resolve([])
    });
  })
}

/**
 * 数值转百分比（小数 → 百分数）
 * @param {number|string} value - 输入的数值（如 0.2025）
 * @param {number} decimals - 保留的小数位数（默认 4）
 * @param {string|boolean} symbol - 是否带符号
 *        true  => 默认加 "%"
 *        false => 不加符号
 *        string => 使用自定义符号，比如 " pct" / " percent"
 * @returns {string} - 转换后的百分比字符串
 */
export const toPercent = (value, decimals = 4, symbol = true) => {
  if (value === null || value === undefined || isNaN(value)) return '';
  const num = Number(value) * 100;
  const formatted = num.toFixed(decimals);
  
  if (symbol === true) {
    return formatted + '%';
  } else if (typeof symbol === 'string') {
    return formatted + symbol;
  } else {
    return formatted;
  }
};

/**
 * 百分比转数值（百分数 → 小数）
 * @param {string|number} value - 输入的百分比（如 "20.25" 或 "20.25%"）
 * @param {number} decimals - 保留的小数位数（默认 4）
 * @returns {number} - 转换后的小数（如 0.2025）
 */
export const toNumber = (value, decimals = 4) => {
  if (value === null || value === undefined || value === '') return 0;
  let str = String(value).replace('%', '');
  let num = Number(str) / 100;
  return Number(num.toFixed(decimals));
}

// 订单物流取消费计算
export const getOrderLogisticsConsumption = (ymsPackageId) => {
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.post_ymsPackageInfo_searchLogisticsCancelPrice :
    api.post_ymsPackageInfo_api_searchLogisticsCancelPrice;
  let query = {
    ymsPackageId: ymsPackageId
  };
  return new Promise((resolve) => {
    axios.post(url, query).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas
        resolve(data);
        return;
      }
      resolve(null);
    }).catch((e) => {
      console.error('getOrderLogisticsConsumption error:', e);
      resolve(null);
    })
  })
}

/**
 * 获取运单号展示类型
 * @param {Object} item 订单行数据
 * @returns {'normal'|'waiting'|'failed'}
 *   - normal：正常展示运单号
 *   - waiting：正在获取运单号
 *   - failed：获取运单号失败
 *
 * 触发条件：carrierStatus=13（面单获取成功）且运单号为空（空值或 '-'）
 * 时间判断（以 getLabelTime 为起点，后台为零时区，需转本地时区后再比较）：
 *   - getLabelTime + 5天 > 当前时间 → waiting（正在获取，后台定时任务处理中）
 *   - getLabelTime + 5天 <= 当前时间 → failed（超过等待期，展示手动获取）
 */
export const getTrackingNumberDisplayType = (item) => {
  const trackingNumber = item.trackingNumber;
  const isEmpty = !trackingNumber;
  if (item.carrierStatus !== 13 || !isEmpty) {
    return 'normal';
  }
  if (!item.getLabelTime) {
    return 'failed';
  }
  const fiveDaysMs = 5 * 24 * 60 * 60 * 1000;
  const createdTimestamp = new Date(uDate.dealTime(item.getLabelTime, 'fulltime')).getTime();
  const isOverFiveDays = createdTimestamp + fiveDaysMs <= Date.now();
  return isOverFiveDays ? 'failed' : 'waiting';
};

/**
 * 计算时间差（返回 "X h: Y min"）
 * @param {string} startTime - 开始时间字符串 (格式: "YYYY-MM-DD HH:mm:ss")
 * @returns {string} - 差值，格式 "X h: Y min"
 */
export const calculateDiffTime = (startTime) => {
  if (!startTime) return '0 h: 0 min';
  const start = new Date(startTime.replace(/-/g, '/'));
  const now = new Date();
  let diffMs = now.getTime() - start.getTime();
  if (diffMs < 0) diffMs = 0;
  const diffMinutes = Math.floor(diffMs / (1000 * 60));
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;
  return `${hours} h ：${minutes} min`;
};

/**
 * 根据 type 累加 amount 并格式化金额
 * @param {Array} list 数据源
 * @param {Number|null} [type=null] 要查询的 type 值，不传则返回所有类型
 * @param {Object} [options] 配置项
 * @param {Boolean} [options.withCurrency=false] 是否返回带币种
 * @param {Number} [options.decimals=2] 小数位数
 * @param {Boolean} [options.thousand=false] 是否千分位
 * @returns {String|Object}
 *   - 单个 type：格式化金额 或 "-"
 *   - 所有 type：{ type值: 格式化金额 或 "-" }
 */
export const sumAmount = (list, type = null, options = {}) => {
  const {withCurrency = false, decimals = 2, thousand = false} = options;
  
  if (!Array.isArray(list)) return type !== null ? '-' : {};
  
  // 分组累计
  const grouped = list.reduce((acc, item) => {
    const key = item.type;
    const amount = item.amount; // 保留原始值，便于判断空
    const currency = item.currency || '';
    
    if (!acc[key]) {
      acc[key] = {amount: 0, currency, hasValue: false};
    }
    
    if (amount !== null && amount !== undefined && amount !== '') {
      acc[key].amount += Number(amount);
      acc[key].hasValue = true;
    }
    return acc;
  }, {});
  
  // 格式化方法
  const format = (entry, original = false) => {
    if (!entry || !entry.hasValue) {
      return '-'; // 金额为空时直接返回 -
    }
    if (original) {
      return Number(entry.amount);
    } else {
      let num = Number(entry.amount).toFixed(decimals);
      if (thousand) {
        num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return withCurrency ? `${num} ${entry.currency}` : num;
    }
  };
  
  // 返回指定 type
  if (type !== null) {
    return format(grouped[type]);
  }
  
  // 返回所有 type
  const result = {};
  Object.keys(grouped).forEach(key => {
    result[key] = format(grouped[key], true);
  });
  
  return result;
};

// 保存设置（key value 形式的）的公共方法
export const saveErpCommonSettingParam = (list, loading = true) => {
  return new Promise((resolve) => {
    axios.post(api.post_erpCommonSettingParam_saveList, list, {
      loading: loading,
      loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
    }).then(response => {
      if (response.data.code === 0) {
        resolve(true);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('saveErpCommonSettingParam error:', e);
      resolve(false);
    })
  })
}

/**
 * @Description: 获取当前本地开发代理请求地址和服务路径
 * @param {String} serviceType - 服务类型(yms | shopping | supplier | distributor)
 * @param {String} returnType - 返回类型: 'link' | 'service' | 'all'，默认 'link'
 * @returns {String|Object} 根据 returnType 返回不同内容
 */
export const getProxyUrl = (serviceType, returnType = 'link') => {
  const systemType = getSystemType();
  // 获取当前环境 URL
  const currentUrl = window.location.href;
  const baseParts = currentUrl.split("//");
  const system = serviceType || systemType;
  
  const service = SERVICE_MAP[system];
  const target = proxyFile["/"]?.target?.replace(/\/$/, "");
  let link = '';
  if (baseParts[1]?.includes("localhost")) {
    link = `${target}${service}`;
  }
  switch (returnType) {
    case "service":
      return service;
    case "all":
      return {link, service};
    case "link":
    default:
      return link;
  }
};

// 获取客户等级所有数据
export const getCustomerLevelAll = () => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsDistributorMerchantGrade_list).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getCustomerLevelAll error:', e);
      resolve([]);
    })
  })
}

// 获取所有商品发货仓
export const getAllGoodsWarehouse = async (servicePlatforms = [], ymsDeliveryPlaceIds = []) => {
  const systemType = getSystemType();
  try {
    const {data: res} = await axios.post(api.post_ymsWarehouse_queryAllDeliveryWarehouse,
      {
        servicePlatforms,
        status: 1,
        ymsDeliveryPlaceIds
      });
    if (res.code !== 0) {
      return [];
    }
    const data = res.datas || [];
    data.forEach(item => {
      item.name = systemType === 'supplier' ? item.name : (item.aliasWarehouseName || item.name);
    });
    return data;
  } catch (e) {
    console.error('getAllGoodsWarehouse error:', e);
    return [];
  }
};

// 获取重量单位的数据
export const getWeightUnitData = () => {
  let list = [];
  return new Promise((resolve) => {
    axios.get(api.get_erpCommonSettingParam_querySettingByType + 'WeightDataEnum').then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        if (data) {
          for (let key in data) {
            list.push({
              value: key,
              name: key,
              conversionValue: data[key]
            })
          }
        }
        resolve(list);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getWeightUnitData error:', e);
      resolve([]);
    })
  })
}

// 获取所有中心仓仓库数据
export const getAllYmsWarehouseData = () => {
  const systemType = getSystemType();
  let url = systemType === 'yms' ? api.get_ymsWarehouse_queryCoreAll : api.get_wmsWarehouse_queryYmsWarehouse;
  return new Promise((resolve) => {
    axios.get(url).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getAllYmsWarehouseData error:', e);
      resolve([]);
    })
  })
}

/**
 * @Description: 根据仓库id获取仓库名称
 * @params: warehouseData 仓库数据源、ymsWarehouseId 仓库id
 */
export const getWarehouseName = (warehouseData, ymsWarehouseId) => {
  return warehouseData.find(item => item.ymsWarehouseId === ymsWarehouseId)?.name || '-';
}

/**
 * @Description: 获取供应商系统的归属仓库的数据
 * @params: supplierMerchantId 供应商商户号
 */
export const getBelongingWarehouseData = (supplierMerchantId) => {
  return new Promise((resolve) => {
    getAllWarehouseData({supplierMerchantSearch: supplierMerchantId}).then((data) => {
      let list = data || [];
      resolve(list);
    })
  });
}

/**
 * @Description: 分销商系统获取对应商户的所属仓库的基础数据
 * @params: distributorMerchantId   分销商商户号
 */
export const getDistributorWarehouseData = (distributorMerchantId) => {
  return new Promise((resolve) => {
    axios.get(api.get_ymsDistributorAscriptionWarehouse_api_query + distributorMerchantId).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        data.forEach((item) => {
          item.name = item.aliasWarehouseName || item.name;
        })
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getDistributorWarehouseData error:', e);
      resolve([]);
    });
  });
}

// 获取地区国家的基础数据
export const getRegionalRcountriesData = (loading) => {
  return new Promise((resolve) => {
    axios.get(api.get_common_country_queryZoneCountry, {loading: loading}).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getRegionalRcountriesData error:', e);
      resolve([]);
    });
  });
}


/**
 * @Description: 根据countryId（国家id）获取对应省级区域的基础数据
 * @params: countryId
 */
export const getStateData = (countryId) => {
  return new Promise((resolve) => {
    axios.get(api.get_common_state_queryByCountryId + `?countryId=${countryId}`).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getStateData error:', e);
      resolve([]);
    });
  });
}

/**
 * @Description: 根据stateCode获取对应市级区域的基础数据
 * @params: stateCode
 */
export const getCityData = (stateCode) => {
  return new Promise((resolve) => {
    axios.get(api.get_common_city_queryByStateCode + `?stateCode=${stateCode}`).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getCityData error:', e);
      resolve([]);
    });
  });
}

/**
 * @Description: 根据cityCode获取对应区级区域的基础数据
 * @params: cityCode
 */
export const getDistrictData = (cityCode) => {
  return new Promise((resolve) => {
    axios.get(api.get_common_district_queryByCityCode + `?cityCode=${cityCode}`).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getDistrictData error:', e);
      resolve([]);
    });
  });
}

// 校验当前用户余额是否充足
export const checkUserBalance = (query) => {
  return new Promise((resolve) => {
    axios.post(api.post_ymsPackageInfo_api_checkMerchantPropertyOrder, query,
      {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001668')}).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('checkUserBalance error:', e);
      resolve(false);
    })
  })
}

/**
 * @Description: 根据供应商商户号批量获取供应商基础数据
 * @params: supplierMerchantIds
 */
export const getSupplierData = (supplierMerchantIds) => {
  const systemType = getSystemType();
  return new Promise((resolve) => {
    let url = systemType === 'yms' ? api.post_ymsSupplierMerchant_queryByIds : api.post_ymsSupplierMerchant_api_queryByIds;
    axios.post(url, supplierMerchantIds).then(response => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        data.map((item) => {
          item.name = _handleMultilingualFields(item.name);
        })
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getSupplierData error:', e);
      resolve([]);
    })
  })
}

/**
 * @Description: 获取运营系统所有属性设置的数据
 * @params: types
 */
export const getCommonSetting = (query) => {
  return new Promise((resolve) => {
    axios.post(api.post_erpCommonSettingParam_queryByParams, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas || [];
        resolve(data);
        return;
      }
      resolve([]);
    }).catch((e) => {
      console.error('getCommonSetting error:', e);
      resolve([]);
    });
  });
}

// 校验是否是在登录状态
export const checkLogin = (isLogin) => {
  return new Promise((resolve) => {
    let params = {};
    if (!isLogin) {
      params = {
        headers: {'Authorization-Special': 'no-Login'}
      };
    }
    axios.get(api.get_distributorErpConfig + '?time=' + new Date().getTime(), params).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('common checkLogin error:', e);
      resolve(false);
    });
  });
}

// 校验当前商户配置项是否完善，不完善时，需要进行系统初始化配置
export const verifyMerchantConfig = () => {
  let erpConfig = commonSessionStorage.getItem("erpConfig") || store.state.erpConfig;
  let merchantId = erpConfig?.userInfo?.merchantId;
  const systemType = getSystemType();
  return new Promise((resolve) => {
    let talg = window.location.href.includes('ticket=');
    if (systemType === 'yms' && talg) {
      getCommonParamKeysData(merchantId, VALIDATEMERCHANTCONFIGKEY, false, true).then((data) => {
        const passed = VALIDATEMERCHANTCONFIGKEY.length === data.length
        resolve(passed)
      }).catch((e) => {
        console.error('verifyMerchantConfig error:', e);
        resolve(false);
      })
    } else {
      resolve(true)
    }
  });
}

// 根据配置项设置获取对应的配置项数据 (配置项存储在运营) 商户维度
export const getConfigurationItemData = () => {
  let erpConfig = commonSessionStorage.getItem("erpConfig") || store.state.erpConfig;
  let merchantId = erpConfig?.userInfo?.merchantId;
  let paramKeys = [];
  let obj = {};
  return new Promise((resolve) => {
    const systemType = getSystemType();
    switch (systemType) {
      case 'yms':
        paramKeys = YMS_MERCHANT_CONFIG_KEY;
        break;
      case 'distributor':
      case 'shopping':
        paramKeys = MALL_DISTRIBUTOR_CONFIG_KEY;
        break;
      case 'supplier':
        paramKeys = SUPPLIER_CONFIG_KEY;
        break;
    }
    getCommonParamKeysData(merchantId, paramKeys, false, false).then((data) => {
      try {
        data.map((item) => {
          let paramValue = isJSON(item.paramValue) ? JSON.parse(item.paramValue) : item.paramValue;
          if (paramKeys.includes(item.paramKey)) {
            obj[item.paramKey] = paramValue;
          }
        });
        store.commit('configurationItemInfo', obj)
        commonLocalStorage.setItem('configurationItemInfo', obj);
        resolve(obj);
      } catch (e) {
        console.error('getConfigurationItemData error:', e);
        resolve({});
      }
    }).catch((e) => {
      console.error('getConfigurationItemData request error:', e);
      resolve({});
    })
  });
}

// 获取存储在供应商端配置项数据(商户维度)
export const getSupplierConfigurationItemData = (value = false) => {
  let obj = {};
  let ticketTalg = window.location.href.includes('ticket=');
  return new Promise((resolve) => {
    let merchantId = store.state.erpConfig?.userInfo?.merchantId;
    let paramKeys = USER_SUPPLIER_CONFIG_KEY;
    if (ticketTalg || value) {
      getCommonParamKeysData(merchantId, paramKeys, false, true).then((data) => {
        data.map((item) => {
          let paramValue = isJSON(item.paramValue) ? JSON.parse(item.paramValue) : item.paramValue;
          if (paramKeys.includes(item.paramKey)) {
            obj[item.paramKey] = paramValue;
          }
        });
        store.commit('supplierConfigurationItemInfo', obj)
        commonLocalStorage.setItem('supplierConfigurationItemInfo', obj);
        resolve(obj);
      }).catch((e) => {
        console.error('getSupplierConfigurationItemData error:', e);
        resolve({});
      })
    } else {
      resolve({});
    }
  });
}

// 获取存储在分销商端配置项数据(商户维度)
export const getDistributorConfigurationItemData = (value = false) => {
  let obj = {};
  let ticketTalg = window.location.href.includes('ticket=');
  return new Promise((resolve) => {
    let merchantId = store.state.erpConfig?.userInfo?.merchantId;
    let paramKeys = USER_DISTRIBUTOR_CONFIG_KEY;
    if (ticketTalg || value) {
      getCommonParamKeysData(merchantId, paramKeys, false, true).then((data) => {
        data.map((item) => {
          let paramValue = isJSON(item.paramValue) ? JSON.parse(item.paramValue) : item.paramValue;
          if (paramKeys.includes(item.paramKey)) {
            obj[item.paramKey] = paramValue;
          }
        });
        store.commit('distributorConfigurationItemInfo', obj)
        commonLocalStorage.setItem('distributorConfigurationItemInfo', obj);
        resolve(obj);
      }).catch((e) => {
        console.error('getDistributorConfigurationItemData error:', e);
        resolve({});
      })
    } else {
      resolve({});
    }
  });
}

/**
 * @Description: 菜单统一处理（隐藏 / 修改名称）
 * @param {Array} menuList 原始菜单
 * @param {Object} options 配置项
 * @param {Array} options.hideMenuKeys 需要隐藏的 menuKey
 * @param {Array} options.hideTypes 需要匹配的 type（可选）
 * @param {Object} options.renameMap 需要修改名称的 map {menuKey: newName}
 */
export const handleCommonMenuData = (menuList = [], options = {}) => {
  const {
    hideMenuKeys = [],
    hideTypes = [],
    renameMap = {}
  } = options;
  const cloneList = JSON.parse(JSON.stringify(menuList));
  const loop = (list = []) => {
    return list.map(item => {
      // 递归 children
      if (item.children && item.children.length) {
        item.children = loop(item.children);
      }
      // 修改名称
      if (renameMap[item.menuKey]) {
        item.name = renameMap[item.menuKey];
      }
      return item;
    }).filter(item => {
      // 根据 menuKey 过滤
      if (hideMenuKeys.includes(item.menuKey)) return false;
      // 根据 type + menuKey 组合过滤
      if (hideTypes.length && item.type && hideTypes.includes(item.type) && hideMenuKeys.includes(item.menuKey)) {
        return false;
      }
      if (item.children && item.children.length === 0) {
        return false;
      }
      return true;
    });
  };
  return loop(cloneList);
};


// 切换语种，存储当前用户设置的语种
export const changeUserLanguages = (lang) => {
  return new Promise((resolve) => {
    axios.put(api.put_erpCommonSettingParam_cutoverLang + lang).then((response) => {
      if (response.data.code === 0) {
        resolve(true);
        return;
      }
      resolve(false);
    }).catch((e) => {
      console.error('changeUserLanguages error:', e);
      resolve(false);
    });
  })
}

// 获取商品条码
export const getProductBarCode = (query) => {
  return new Promise((resolve) => {
    axios.post(api.post_productGoods_barcode, query).then((response) => {
      if (response.data.code === 0) {
        let data = response.data.datas;
        resolve(data);
        return;
      }
      resolve('');
    }).catch((e) => {
      console.error('getProductBarCode error:', e);
      resolve('');
    })
  })
}

// 根据地址栏访问的当前路由，获取当前对应的路由菜单key
export const getRouteMenuKey = (to, type) => {
  const pathArr = to.meta && to.meta.parentPath ? to.meta.parentPath.split('/') : to.path.split('/');
  const pathName = pathArr[2] ? `${pathArr[1]}_${pathArr[2]}` : pathArr[1];
  return `${type}_${pathName}`;
}

// 获取已开启平台
export const getEnabledPlatforms = async (platformIds = [], ymsProductCategoryId) => {
  const systemType = getSystemType();
  const apiUrl = systemType === 'yms' ? api.post_ymsPlatform_query : api.post_ymsPlatform_api_query;
  const {data} = await axios.post(apiUrl, {
    platformIds,
    platformType: 'sales',
    ymsProductCategoryId
  });
  if (data?.code !== 0) return [];
  const platformList = data.datas || [];
  const config = commonLocalStorage.getItem('configurationItemInfo') ?? store.state.configurationItemInfo;
  const enabledPlatformIds = config?.distributorPlatformSet || [];
  const result = platformList.filter(item => enabledPlatformIds.includes(item.platformId));
  if (!result.length) return [];
  store.commit('platformGroup', result);
  commonLocalStorage.setItem('platformGroup', result);
  return handleImagesData(result);
};

// 获取批量查询邮寄方式的数据
export const getQueryCarrierShippingName = async (list) => {
  const systemType = getSystemType();
  const url =
    systemType === 'distributor'
      ? api.post_carrierShippingMethod_api_queryCarrierShippingName
      : api.post_carrierShippingMethod_queryCarrierShippingName;
  try {
    const {data} = await axios.post(url, list);
    return data?.code === 0 ? data.datas || [] : [];
  } catch {
    return [];
  }
};

// 获取当前系统所有用户信息
export const getAllUsersInfo = async () => {
  const systemType = getSystemType();
  const urlMap = {
    yms: api.get_ymsCoreUserInfo_getAllUser,
    supplier: api.get_ymsSupplierUserInfo_getAllUser,
    distributor: api.get_ymsDistributorUserInfo_getAllUser
  };
  const baseUrl = urlMap[systemType];
  if (!baseUrl) return true;
  try {
    const {data} = await axios.get(`${baseUrl}?time=${Date.now()}`);
    return data?.code === 0 && data.datas ? data.datas : true;
  } catch (err) {
    console.log('--获取用户名数据失败---', err);
    return true;
  }
};

/**
 * @Description: 获取所有国家的基础数据
 * @params:
 *  - displayLang: 下拉展示语言，默认中文 'cn'（可传 'en'）
 *  - original: 是否返回原始数据；false 时会过滤 areaCode 为 null 的国家
 *
 * @return Array<Country>
 */
export const getAllCountrysData = async (displayLang = 'cn', original = false) => {
  const language = getSetLanguages();
  try {
    const {data} = await axios.get(`${api.get_common_countrys_query}?time=${Date.now()}`);
    const list = data?.code === 0 ? (data.datas || []) : [];
    if (!Array.isArray(list) || list.length === 0) return [];
    const areaCodeList = ['86', '852', '886'];
    const processed = list.map((item) => {
      const cnName = item.cnName || '';
      const enName = item.enName || '';
      const areaCode = item.areaCode;
      const name = language === defaultLanguages ? cnName : enName;
      const next = {...item, name};
      
      if (areaCode && displayLang === 'en') {
        const displayName = areaCodeList.includes(areaCode) ? cnName : enName;
        next.twoCodeName = displayName;
        next.areaCodeName = `${displayName} +${areaCode}`;
      }
      return next;
    });
    // original=false：过滤 areaCode 为 null
    return original ? processed : processed.filter(i => i.areaCode !== null);
  } catch (err) {
    console.log('--获取国家数据失败---', err);
    return [];
  }
};

// 根据国家的twoCode值，获取对应国家的areaCode 区号
export const getAreaCodeByCountryCode = (countrysData = [], countryCode) => {
  if (!countryCode || !Array.isArray(countrysData) || countrysData.length === 0) return '';
  return countrysData.find(item => item?.twoCode === countryCode)?.areaCode ?? '';
};

/**
 * @Description: 批量获取数据集(查询list)，支持查询多个key值
 * @params:  paramsKeyList 是对应数据集的key值集合
 */
export const getDataSetBatchList = async (paramsKeyList) => {
  try {
    const {data} = await axios.post(api.post_dataSet_queryByTypesForList, paramsKeyList);
    return data?.code === 0 ? data.datas || [] : [];
  } catch {
    return [];
  }
};

/**
 * @Description: 获取单个数据集(查询list)
 * @params: paramsKey 是对应数据集的key值
 */
export const getDataSetList = async (paramsKey) => {
  try {
    const {data} = await axios.get(api.get_dataSet_queryForList + `?type=${paramsKey}`);
    return data?.code === 0 ? data.datas || [] : [];
  } catch {
    return [];
  }
};

/**
 * @Description: 获取数据集(查询Map)key、value对象的形式
 * @params:
 *  paramsKey 是对应数据集的key值
 */
export const getDataSetMap = async (paramsKey) => {
  try {
    const {data} = await axios.get(api.get_dataSet_queryForMap + `?type=${paramsKey}`);
    return data?.code === 0 ? data.datas || '' : '';
  } catch {
    return '';
  }
};

/**
 * 根据枚举 key + value 获取枚举名称
 * @param {Array} enumData 枚举数据
 * @param {String} enumKey 枚举 key
 * @param {*} value 枚举值
 * @param {'number'|'string'} valueType value 类型
 * @returns {String}
 */
export const getEnumName = (enumData, enumKey, value, valueType = 'string') => {
  const valueMap = {
    number: v => Number(v),
    string: v => String(v)
  };
  const targetValue = valueMap[valueType](value);
  return (enumData.find(i => i.enumKey === enumKey && valueMap[valueType](i.value) === targetValue)?.name || '-');
};

/**
 * 根据 enumKey 获取枚举列表
 * @param {Array} enumData 枚举数据源
 * @param {String} enumKey 枚举 key
 * @param {'number'|'string'} valueType value 类型
 * @returns {Array<{value:any,title:string}>}
 */
export function getEnumList(enumData, enumKey, valueType = 'string') {
  const valueMap = {
    number: v => Number(v),
    string: v => String(v)
  };
  return (enumData || [])
    .filter(item => item.enumKey === enumKey)
    .map(item => ({
      value: valueMap[valueType](item.value),
      title: item.name,
      name: item.name,
      label: item.name
    }));
}

/**
 * @Description: 打印
 * @params:
 */
export const printHtmlUrl = async (path, id) => {
  if (!path) return;
  // 处理非 http 路径
  if (!path.includes('http')) {
    const erpConfig = commonSessionStorage.getItem('erpConfig') || store.state.erpConfig;
    let baseUrl = erpConfig?.filenodeViewTargetUrl;
    if (baseUrl === './filenode/s') {
      baseUrl = getProxyUrl() ? `${getProxyUrl()}/filenode/s` : `${window.location.href.split(/[^/]+(?!.*html)/)[0]}filenode/s`;
    }
    path = baseUrl + path;
  }
  const ext = path.split('.').pop();
  // html 文件
  if (ext === 'html') {
    const res = await axios.get(`${api.get_loadUrlTxt}?url=${path}`);
    if (res.data.code === 0) {
      return {
        content: res.data.datas,
        postId: id
      };
    }
  }
  // 菜鸟打印
  if (ext === 'cainiao') {
    const websocket = await initCainiao();
    const res = await axios.get(`${api.get_loadUrlTxt}?url=${path}`);
    if (res.data.code === 0) {
      await cainiaoPrint(websocket, id, res.data.datas);
      return {
        content: res.data.datas,
        postId: id,
        printType: 'cainiao'
      };
    }
  }
  // 图片打印
  if (path.includes('.png')) {
    return {
      content: `
        <div style="width:198pt">
          <img width="100%" src="${path}" />
        </div>`,
      postId: id
    };
  }
  // 默认：pdf
  return {
    pdf: path,
    postId: id
  };
};

/**
 * @Description: 获取云卖分类的数据
 * @params: 类型type 默认获取有层级关系的树状数据，type值为 tile时，获取平铺的数据, original 返回原始数据
 */
export const getCloudTreeData = (url, type, expand, ymsSiteId = null, params = {}) => {
  const erpConfig = commonSessionStorage.getItem('erpConfig');
  const siteId = ymsSiteId || erpConfig?.ymsSite?.ymsSiteId;
  const query = {ymsSiteId: siteId, ...params};
  // ===== 递归清理 children =====
  const clearEmptyChildren = (list) => {
    list.forEach(item => {
      if (item.children && item.children.length) {
        clearEmptyChildren(item.children);
      } else {
        delete item.children;
      }
    });
    return list;
  };
  // ===== 分类平铺排序 =====
  const sortTileCategory = (data) => {
    if (!data.length) return [];
    data.forEach(i => {
      i.levelName = i.productCategoryNavigation.split('->')[0];
    });
    const groups = {};
    data.forEach(item => {
      const key = item.levelName;
      (groups[key] ||= []).push(item);
    });
    const sorted = [];
    const noSort = [];
    Object.values(groups).forEach(list => {
      const levels = {1: [], 2: [], 3: []};
      list.forEach(item => {
        const level = item.productCategoryNavigation.split('->').length;
        levels[level]?.push(item);
      });
      levels[1].forEach(i => i.sortNo *= 10);
      levels[2].forEach(i => {
        const p = levels[1].find(p => p.productCategoryNavigation.split('->')[0] === i.productCategoryNavigation.split('->')[0]);
        if (p) i.sortNo = (i.sortNo + p.sortNo) * 100;
      });
      levels[3].forEach(i => {
        const p = levels[2].find(p => p.productCategoryNavigation.split('->')[1] === i.productCategoryNavigation.split('->')[1]);
        if (p) i.sortNo = (i.sortNo + p.sortNo) * 1000;
      });
      const listAll = [...levels[1], ...levels[2], ...levels[3]].sort(handerDataSorting('sortNo', 'asc'));
      (list[0]?.sortNo ? sorted : noSort).push(...listAll);
    });
    return [...sorted, ...noSort];
  };
  // ===== 主流程 =====
  return axios.post(url, query).then(res => {
    if (res.data.code !== 0) return [];
    const data = res.data.datas || [];
    if (!data.length) return [];
    const list = data.sort(sortCategory);
    // 原始数据
    if (type === 'original') return list;
    // 平铺数据
    if (type === 'tile') {
      return sortTileCategory(list).map(i => ({
        ...i,
        title: i.productCategoryNavigation
      }));
    }
    // 树状数据（默认）
    const tree = handlerClassifyData(list, 'productCategoryNavigation', '->', expand);
    const result = clearEmptyChildren(tree);
    store.commit('classificationData', result);
    if (!isAlibabaDistributor()) {
      commonLocalStorage.setItem('classificationData', result);
    }
    return result;
  });
}

// 处理分类数据为树形结构
export const handlerClassifyData = (data = [], key, sign, expand = true) => {
  if (!data.length) return [];
  const map = {};
  const roots = [];
  data.forEach(item => {
    item.expand = expand;
    item.switchTalg = false;
    item.children = [];
    const name = item[key];
    const index = name.lastIndexOf(sign);
    const parentKey = index > -1 ? name.slice(0, index) : null;
    item.title = index > -1 ? name.slice(index + sign.length) : name;
    map[name] = item;
    if (parentKey && map[parentKey]) {
      map[parentKey].children.push(item);
    } else {
      roots.push(item);
    }
  });
  return roots;
};

// 处理分类数据排序
export const sortCategory = (a, b) => {
  const key = 'productCategoryNavigation';
  const sortKey = 'sortNo';
  const aLen = a[key].split('->').length;
  const bLen = b[key].split('->').length;
  if (aLen !== bLen) {
    return aLen < bLen ? -1 : 1;
  }
  if (a[sortKey] !== b[sortKey]) {
    return a[sortKey] < b[sortKey] ? -1 : 1;
  }
  return 0;
};

/**
 * @Description: 根据库位id获取仓库/库区/库位信息
 * @params ymsWarehouseLocationIds Array
 * @params tableData Array | {data, childKey}
 * @params options Object 可选参数 { isReturnResponse, apiUrl }
 * isReturnResponse 是否返回原始数据
 */
export const getWarehouseManageInfo = async (
  ymsWarehouseLocationIds,
  tableData,
  {
    isReturnResponse = false,
    apiUrl = api.post_ymsWarehouse_ymsProductInfo_ymsWarehouseLocationIds
  } = {}
) => {
  const extractRows = (tableData) => {
    if (Array.isArray(tableData)) return tableData;
    if (tableData?.data && Array.isArray(tableData.data)) {
      const result = [];
      tableData.data.forEach(row => {
        let target = row;
        tableData.childKey?.forEach(key => {
          target = target?.[key] || [];
        });
        Array.isArray(target) && result.push(...target);
      });
      return result;
    }
    return [];
  };
  try {
    const res = await axios.post(apiUrl, ymsWarehouseLocationIds);
    if (res.data.code !== 0) return tableData;
    const warehouseData = res.data.datas || [];
    if (isReturnResponse) return warehouseData;
    const locationMap = new Map();
    warehouseData.forEach(w => {
      w.ymsWarehouseBlocks?.forEach(b => {
        b.ymsWarehouseLocations?.forEach(l => {
          locationMap.set(l.ymsWarehouseLocationId, {
            warehouseName: w.name,
            warehouseBlockName: b.name,
            warehouseBlockCode: b.code,
            warehouseLocalName: l.code
          });
        });
      });
    });
    const rows = extractRows(tableData);
    rows.forEach(item => {
      const info = locationMap.get(item.ymsWarehouseLocationId);
      if (info) Object.assign(item, info);
    });
    return Array.isArray(tableData) ? tableData : tableData.data;
  } catch (err) {
    console.error("getWarehouseManageInfo error:", err);
    return tableData;
  }
};

// 查询云卖物流数据
export const getYunLogisticsAll = async () => {
  const urlMap = {
    yms: api.post_ymsLogisService_queryAll,
    distributor: api.post_ymsLogisService_api_queryAll,
    shopping: api.post_ymsLogisService_api_queryAll,
  };
  const systemType = getSystemType();
  const url = urlMap[systemType];
  if (!url) return [];
  const requestData = systemType === 'yms' ? null : {merchantType: 2};
  try {
    const res = await axios.post(url, requestData);
    if (res.data.code === 0) {
      return res.data.datas || [];
    }
    return [];
  } catch (err) {
    console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001669'), err);
    return [];
  }
};

/**
 * @Description: 获取对应系统指引所属模块的菜单数据
 * @params: menuData 菜单数据   systemType: 1分销商系统  2运营系统  3供应商系统
 */
export const getSystemModuleList = (menuData, systemType) => {
  const mergedMenu = systemType === "3" && menuData && typeof menuData === "object"
    ? Object.values(menuData).flat() : Array.isArray(menuData) ? menuData : [];
  // 递归将树结构转成平铺数组
  const flattenTree = (tree = []) => {
    return tree.reduce((acc, node) => {
      acc.push(node);
      if (node.children && node.children.length) {
        acc.push(...flattenTree(node.children));
      }
      return acc;
    }, []);
  };
  return flattenTree(mergedMenu).filter(item => item.guidanceModule);
};

/**
 * @Description:获取所有规则项的枚举数据
 * @author jing
 * @date 2026/3/4 10:11
 * @params:
 */
export const getAllRuleItemEnumData = async () => {
  let enumKeyList = ['YmsRuleDisplayEnum', 'YmsRuleGroupEnum'];
  try {
    const data = getDataSetBatchList(enumKeyList);
    return data || [];
  } catch (err) {
    console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001670'), err);
    return [];
  }
};


/**
 * @Description: 处理规则项数据通过枚举形式替换条件、分组描述内容（进行翻译）
 * @author jing
 * @date 2026/3/4 09:52
 * @params:
 */

export const processingRuleItemData = (ruleItemEnumData, data) => {
  return new Promise((resolve) => {
    const rulesList = data.rules || [];
    const displayMap = {};
    const groupMap = {};
    ruleItemEnumData.forEach(item => {
      // 条件描述
      if (item.enumKey === 'YmsRuleDisplayEnum') {
        displayMap[item.code] = item.name;
      }
      // 分组描述
      if (item.enumKey === 'YmsRuleGroupEnum') {
        groupMap[item.code] = item.name;
      }
    });
    // 替换数据
    rulesList.forEach(rule => {
      if (displayMap[rule.display]) {
        rule.display = displayMap[rule.display];
      }
      if (groupMap[rule.group]) {
        rule.groupDescription = groupMap[rule.group];
      }
    });
    resolve(data);
  });
};

/**
 * @Description: 处理文档类目结构数据，兼容翻译，当没有文化英文时，默认展示中文值
 * @author jing
 * @date 2026/3/9 14:04
 * @params:
 */

export const fixCategoryLang = (list, key = 'name') => {
  if (!Array.isArray(list) || list.length === 0) return [];
  const zhItem = list.find(i => i.language === defaultLanguages);
  const zhValue = zhItem?.[key] || '';
  return list.map(item => {
    if (item.language === 'en-US' && !item?.[key]) {
      return {
        ...item,
        [key]: zhValue
      };
    }
    return item;
  });
};

/**
 * @Description: 动态获取导入模板
 * @author jing
 * @date 2026/3/17 10:18
 * @params:
 * 运营系统导入模板key:
 * 物品属性模板: ymsProductAttributeTemplate
 * 库位导入模板: ymsWarehouseLocation
 * 物流账单模板: logisticsBill
 * 订单实重模板: packageWeight
 * 库存余量模板：ymsInventory
 *
 * 供应商系统导入模板key:
 * 库存导入模板: inventory
 * 批量上架/停售模板: updateProductGoodsStatus
 * 备货单导入模板：supplierStockOrder
 *
 * 分销商系统导入模板key:
 * 商品别名模板：goodsMappingTemplate
 * 商品关联关系模板：ymsProductGoodsRelationType
 *
 */

export const getImportTemplate = async (type, query = {}) => {
  try {
    const res = await axios.post(api.get_ymsImportTemplate_excelImportTemplate + type, query);
    if (res.data.code === 0) {
      let url = res.data.datas;
      if (url) {
        downloadTemplateFile(url, '_blank')
      }
      return url;
    }
    return null;
  } catch (err) {
    console.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001671'), err);
    return [];
  }
};

/**
 * @Description: 处理运费文案
 * @author jing
 * @date 2026/3/19 09:57
 * @params:
 */

export const processFreightText = (priceType, showLogisticsFeeConfig, test) => {
  const systemType = getSystemType();
  let text = '';
  let testText = '';
  let list = [
    {
      priceType: 1,
      testShippingCostText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001672'),
      actualFreightReceivedText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001673'), // 实收运费
      prepaidFreightText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001674'), // 预收运费
      prepaidFreightChargesText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001675'), // 预扣运费
    },
    {
      priceType: 2,
      testShippingCostText: // + 挂号费 + 操作费
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001676') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001677') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001678') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001679'),
      actualFreightReceivedText:
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001676') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001677') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001680') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001681') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001678') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001679') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001682') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001683'),
      prepaidFreightChargesText:
        aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001676') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001677') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001684') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001678') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001679') +
        '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001685')
    },
    {
      priceType: 3,
      testShippingCostText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001686'),
      actualFreightReceivedText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001687'), // 实收运费
      prepaidFreightText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001688'), // 预收运费
      prepaidFreightChargesText: '<br/>' + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001689'),
    },
  ]
  list.map((item) => {
    if (item.priceType === priceType) {
      if (showLogisticsFeeConfig) {
        if (systemType === 'yms') {
          if ([1, 3].includes(priceType)) {
            text = item.testShippingCostText + item.actualFreightReceivedText + item.prepaidFreightText;
          } else {
            text = item.actualFreightReceivedText;
          }
        } else {
          if ([1, 3].includes(priceType)) {
            text = item.testShippingCostText + item.prepaidFreightChargesText;
          } else {
            text = item.prepaidFreightChargesText;
          }
        }
      } else {
        text = item.testShippingCostText;
      }
      testText = item.testShippingCostText.replace(/测试/g, '');
    }
  });
  return test ? testText : text;
};

/**
 * @Description: 只按国家集合匹配，完全相同则覆盖，否则追加
 * @author jing
 * @date 2026/3/20 16:36
 */

export const mergeByCountriesStrict = (oldList = [], newList = []) => {
  // 判断国家集合是否完全相同（忽略顺序）
  const isSameCountries = (arr1 = [], arr2 = []) => {
    if (arr1.length !== arr2.length) return false;
    const set1 = new Set(arr1);
    return arr2.every(i => set1.has(i));
  };
  // 提取国家code数组
  const getCodes = (item) => {
    return (item.carrierShippingMethodPriceModelZoneCountryList || []).map(i => i.twoCode);
  };
  const result = [...oldList];
  newList.forEach(newItem => {
    const newCodes = getCodes(newItem);
    const index = result.findIndex(oldItem => {
      const oldCodes = getCodes(oldItem);
      return isSameCountries(oldCodes, newCodes);
    });
    // 国家完全相同 → 覆盖
    if (index > -1) {
      const oldItem = result[index];
      result[index] = {
        ...oldItem,
        carrierShippingMethodSectionChargesList:
        newItem.carrierShippingMethodSectionChargesList,
        priceType: newItem.priceType,
        formula: newItem.formula
      };
    }
    // 不相同 → 追加
    else {
      result.push(newItem);
    }
  });
  return result;
};

/**
 * @Description: 获取完整图片地址，自动拼接图片地址
 * @author jing
 * @date 2026/5/19 17:41
 * @params:
 */
export const getFullImagePath = (path, serviceType = '', thumbnail) => {
  if (!path) return '';
  // 已经是完整地址
  if (regular.matchHttpHttps.test(path)) {
    return path;
  }
  const systemType = getSystemType();
  const system = serviceType || systemType;
  const service = SERVICE_MAP[system] || '';
  const erpConfig = commonSessionStorage.getItem('erpConfig') || store.state.erpConfig;
  const filenodePath = erpConfig?.filenodeViewTargetUrl?.split('.')?.[1] || '/filenode/s';
  let link = `${location.origin}${service}${filenodePath}${path}`;
  // 本地环境
  if (location.hostname.includes('localhost')) {
    const target = proxyFile['/']?.target?.replace(/\/$/, '') || '';
    return `${target}${service}${filenodePath}${path}`;
  }
  // 指定了 serviceType
  if (serviceType) {
    return link;
  }
  // 正式环境
  if (thumbnail) {
    return link;
  } else {
    return erpConfig?.filenodeViewTargetUrl ? `${erpConfig.filenodeViewTargetUrl}${path}` : link;
  }
};


/**
 * @Description: 获取所有供应商商户信息
 * @author jing
 * @date 2026/3/24 17:13
 * @params:
 */

export const getAllSuppliersData = async (params) => {
  try {
    let query = {
      createdStartTime: null,
      createdEndTime: null,
      ymsMerchantIds: [], // 供应商编号
      mobiles: [], // 手机号
      emails: [], // 邮箱
      searchValue: '',
      upDown: 'down',
      orderBy: 'createdTime',
      supplierAuditStatus: 2,
      supplierStatus: 1,
      ...params
    }
    const {data} = await axios.post(api.post_ymsSupplierMerchant_queryList, query);
    let newData = data?.code === 0 ? data.datas || [] : [];
    newData.forEach((item) => {
      let name = _handleMultilingualFields(item.name);
      item.supplierMerchantName = name + ' ' + `(${item.ymsMerchantId})`
    });
    return newData;
  } catch {
    return [];
  }
}

/**
 * @Description: 分销商系统获取当前用户的可用余额相关信息
 * @author jing
 * @date 2026/5/12 14:43
 * @params: merchantId 分销商商户ID
 */

export const getDistributorBalanceInfo = async (merchantId) => {
  try {
    const {data} = await axios.get(api.get_ymsMerchantProperty_api_queryByYmsDistributorMerchantId + merchantId);
    if (data.code !== 0 || !data.datas) {
      return null;
    }
    const obj = data.datas;
    return obj;
  } catch (e) {
    return null;
  }
};

/**
 * @Description: 处理当前用户的可用余额计算
 * @author jing
 * @date 2026/5/12 14:48
 *
 * distributorBalance 分销商余额
 * distributorRemainQuota 分销商剩余额度
 * distributorWithholdingAmount 分销商预扣金额
 * distributorInitialQuota 分销商初始额度
 *
 *1. 预扣金额≤余额，剩余可用余额=余额-预扣金额；已用额度=初始额度-剩余可用额度；
 *2. 预扣金额＞余额，则校验“剩余可用额度”-（预扣金额-余额）的值，能否≥0；若能，则剩余可用余额=0，
 *已用额度=初始额度-剩余可用额度（此处剩余可用额度表示是减去预扣金额的值，公式=此前剩余信用额度-“预扣金额-余额”）；
 *若不能，则剩余可用额度=0，已用额度=初始额度，剩余可用余额=余额+剩余可用额度-预扣金额（计算结果为负数，公式中剩余可用额度是减至0之前的值）；
 *
 */
export const calculateDistributorAmount = (obj) => {
  const formatAmount = (amount) => (amountHandel(amount) === '-0.00' ? '0.00' : amountHandel(amount));
  let {distributorBalance, distributorRemainQuota, distributorWithholdingAmount, distributorInitialQuota} = obj;
  const amountToDeductFromQuota = distributorWithholdingAmount - distributorBalance;
  let number = distributorRemainQuota - amountToDeductFromQuota; // 计算之后的剩余额度
  
  let balance = 0;
  let distributorUsedQuota = 0;
  
  // 预扣金额≤余额
  if (distributorWithholdingAmount <= distributorBalance) {
    balance = formatAmount(distributorBalance - distributorWithholdingAmount);
    distributorUsedQuota = formatAmount(distributorInitialQuota - distributorRemainQuota);
  }
  // 预扣金额>余额
  else {
    if (number >= 0) {
      balance = 0;
      distributorUsedQuota = formatAmount(distributorInitialQuota - number);
    } else {
      distributorUsedQuota = formatAmount(distributorInitialQuota);
      balance = formatAmount(distributorBalance + distributorRemainQuota - distributorWithholdingAmount);
    }
  }
  
  return {
    ymsDistributorMerchantId: obj.ymsDistributorMerchantId,
    currency: obj.currency,
    balance, // 当前可用余额
    distributorUsedQuota, // 已使用额度
    isSettingQuota: obj.isSettingQuota, // 是否设置额度  0否  1是
    distributorInitialQuota: formatAmount(distributorInitialQuota), // 初始总额度
    distributorWithholdingAmount: formatAmount(distributorWithholdingAmount), // 预扣金额
  }
};

// 清除表单指定字段校验状态
export const clearFormFieldValidate = (form, fields = []) => {
  if (!form || !form.fields) return;
  form.fields.forEach((item) => {
    if (fields.includes(item.prop)) {
      item.validateState = '';
      item.validateMessage = '';
    }
  });
};

/**
 * @Description: 打印商品二维码
 * @date 2026/6/1 15:25
 * @params: list 需要打印的商品列表
 * @return: 接口成功(code===0)时返回 datas 数据，由调用方自行处理（如调用 commonPrint）
 */
export const printProductQRCode = async (list) => {
  try {
    const {data} = await axios.post(api.post_productGoods_appendProductGoodsExpressBill,
      list, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')});
    if (data.code === 0) {
      return data.datas;
    } else if (data.code === 220026) {
      Modal.warning({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000618'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000619'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316')
      });
    }
  } catch (e) {
    console.error('printProductQRCode error:', e);
  }
}



